import { MetaPhotoErrorCode, TikTokErrorCode, TikTokFailReasonCode } from '../types/integrations/integrations.types';
import { JourneyPositionEnum } from '../types/journey/journey.types';
import { ReviewSource } from '../types/reviewManagement/reviewManagement.type';
import { OrderSource } from '../types/ticket/ticket.types';
import { GuestSegmentTypes } from '../types/guestSegment/guestSegment.types';
import { NotificationType } from './enum';

export const DUMMY_GUEST_USER = {
  name: 'Guest User',
  email: 'guest@example.com',
  phone: '0000000000',
};

export const SUCCESS_MESSAGE = {
  DELETE_CROPPED_IMAGE: {
    IMAGE_DELETE_SUCCESS: 'Image deleted successfully',
  },
  UPLOAD_IMAGE: {
    CREATED: 'Image uploaded successfully',
    IMAGE_UPLOAD_FAIL: 'Error while uploading image',
  },
  PAY_SCHEDULE: {
    PAY_SCHEDULE_REQUEST_CREATED: 'Pay schedule has been created successfully.',
    GET_PAY_SCHEDULES_REQUEST: 'Pay schedules retrieved successfully.',
    UPDATE_PAY_SCHEDULE_REQUEST: 'Pay schedule updated successfully.',
    GET_PAY_SCHEDULE_PAYDAYS_REQUEST: 'Pay days retrieved successfully',
    GET_ACTIVE_PAY_SCHEDULE_REQUEST: 'Get Active Pay Schedule',
  },
  ACCOUNTING: {
    CHARTS_OF_ACCOUNTS: {
      RETRIEVED: 'Charts of Account data retrieved successfully',
      UPLOADED: 'Charts of Account data uploaded successfully',
      LOGS_RETRIEVED: 'Charts of Account logs retrieved successfully',
      ALL_LOGS_RETRIEVED: 'Charts of Account All logs retrieved successfully',
    },
    BILL_PAYMENT: {
      UPDATED: 'Invoice(s) updated successfully',
      RETRIEVED: 'Invoices  retrieved  successfully',
    },
    JOURNAL_ENTRIES: {
      RETRIEVED: 'Journal entries retrieved successfully',
      CREATED: 'Journal entry created successfully',
      REVERSED: 'Journal entry reversed successfully',
    },
    PAYMENT_TYPES: {
      RETRIEVED: 'Payment Types retrieved successfully',
    },
    SALES_CONTROLLER: {
      RETRIEVED: 'Sales Controllers data retrieved successfully',
      ERROR_SALES_ORDER_BEFORE_CLOSEOUT: 'Sales order data is unavailable before the restaurant closeout time',
      UPDATED: 'Sales controller updates successfully saved',
      LOGS_RETRIEVED: 'Sales Controllers Logs retrieved successfully',
      NO_LOGS_RECORD_FOUND: 'No logs found for the Sales Controller.',
      NO_RECORD_FOUND: 'No Record found for the Sales Controller.',
      FUTURE_DATE_ERROR: 'Sales data for future dates is unavailable. Please select a valid date',
      ZERO_DIFFERENCE: 'The sales controller must have a net zero balance',
    },
    RECONCILIATION: {
      RECONCILIATION_RETRIEVED: 'Reconciliation entries retrieved successfully',
      RECONCILIATION_DETAILS_RETRIEVED: 'Reconciliation entry retrieved successfully',
      AIO_TRANSACTIONS_RETRIEVED: 'AIO Transaction entries retrieved successfully',
      RECONCILIATION_ENTRY_CREATED: 'Reconciliation entry created successfully',
      POSSIBLE_MATCHES_RETRIEVED: 'Possible matches retrieved successfully',
      DELETE_SUCCESSFUL: 'Reconciliation entry deleted successfully',
    },
  },
  ORDEROUT: {
    ORDER_RECEIVED: 'Orders received successfully',
    ORDER_CANCELLED: 'Orders cancelled successfully',
    RESTAURANT_ONBOARDING: 'Restaurant Onboarding successfull',
    ORDER_ACCEPTED_REJECTED: 'Order accepted/rejected successfully',
  },
  KITCHEN_HUB: {
    ORDER_RECEIVED: 'Orders received successfully',
    ORDER_CANCELLED: 'Orders cancelled successfully',
    RESTAURANT_ONBOARDING: 'Restaurant Onboarding successfull',
    ORDER_ACCEPTED_REJECTED: 'Order accepted/rejected successfully',
    DELETED_SUCCESSFULLY: 'Integration account disconnected successfully',
    PAUSED_SUCCESSFULLY: 'Integration account paused successfully',
    RESUMED_SUCCESSFULLY: 'Integration account resumed successfully',
    ORDER_UPDATED: 'Orders updated successfully',
    SUCCESSFULL_DISABLE: 'KitchenHub info removed as third-party onboarding is disabled',
  },
  BENEFITS: {
    BENEFIT_CREATED: 'Benefit created successfully',
    BENEFIT_FETCHED: 'Benefit fetched successfully',
    BENEFIT_UPDATED: 'Benefit updated successfully',
    BENEFIT_DELETED: 'Benefit deleted successfully',
  },
  EMPLOYEE_BENEFITS: {
    BENEFIT_ASSIGNED: 'Benefit assigned successfully',
    BENEFIT_FETCHED: 'Employee benefit fetched successfully',
    BENEFIT_UPDATED: 'Employee benefit updated successfully',
    BENEFIT_DELETED: 'Employee benefit deleted successfully',
  },
  CHECK_HQ_PAYROLL: {
    PAYROLL_PROCESS_INITIATED: 'Payroll process has been initiated successfully.',
    PAYROLL_PROCESSED_SUCCESSFULLY: 'Payroll has been processed successfully.',
    PAYROLL_RECORD_UPDATED: 'Payroll record has been updated successfully.',
    PAYROLL_SUMMARY_RETRIEVED: 'Payroll summary retrieved successfully.',
    PAYROLL_LIST_FETCHED_SUCCESSFULLY: 'Payroll list fetched successfully.',
    PAYROLL_CREATE_SUCCESSFULLY: 'Payroll created successfully.',
    PAYROLL_DETAILS_FETCHED_SUCCESSFULLY: 'Payroll details fetched successfully.',
    PAYROLL_APPROVED_SUCCESSFULLY: 'Payroll approved successfully.',
    PAYROLL_DELETED_SUCCESSFULLY: 'Payroll deleted successfully.',
    PAYROLL_UPDATED_SUCCESSFULLY: 'Payroll updated successfully.',
  },
  CHECK_HQ_PAYOUT: {
    PAYOUTS_FETCHED_SUCCESSFULLY: 'Payouts fetched successfully',
  },
  CHECK_HQ_ONBOARDING: {
    GET_EMPLOYEE_ONBOARD_LINK: 'Onboarding link retrieved successfully',
  },
  QR: {
    QR_CREATED: 'QR created successfully',
    QR_ALREADY_EXISTS: 'QR already exists',
    QR_UPDATED: 'QR updated successfully',
  },
  QR_ORDER: {
    INITIATE_ORDER: 'Order initiated successfully',
    PRE_AUTH: 'Pre Auth Successful',
    INCREMENT_AUTH: 'Increment Auth Successful',
    CAPTURE_PAYMENT: 'Capture Payment Successful',
    FETCHED_ACTIVE_TICKETS: 'Successfully fetched active tickets',
    FETCHED_QR_LINK: 'Successfully fetched QR link',
  },
  EMAIL: {
    WEEKLY_REPORT_SUBJECT: 'Weekly Report',
    WEEKLY_REPORT_BODY: 'PFA Weekly Report',
    DAILY_REPORT_SUBJECT: 'Daily Report',
    DAILY_REPORT_BODY: 'PFA Daily Report',
    EMAIL_SENT: 'Email sent successfully',
    EMPLOYEE_TIME_CARD_SUBJECT: 'Employee Time Card Report',
    EMPLOYEE_TIME_CARD_BODY: 'PFA Employee Time Card Report',
  },
  PLAID: {
    SAVE_TOKEN: 'Token saved successfully.',
    UPDATE_TOKEN: 'Token updated successfully.',
    FETCH: 'Bank fetched successfully.',
    GET_BANK_DETAILS: 'Bank details retrieved successfully.',
    DELETE_BANK: 'Bank deleted successfully.',
    GET_PUBLIC_TOKEN: 'Public token retrieved successfully.',
    CREATE_LINK_TOKEN: 'Link token created successfully.',
    EXCHANGE_PUBLIC_TOKEN: 'Public token exchanged successfully.',
    GET_TRANSACTIONS: 'Transactions retrieved successfully',
    PAYMENT_STATUS: 'Payment status retrieved successfully',
    TRANSFER_PAYMENT: 'Payment successfully transferred',
    GET_CREDIT_CARD_LIABILITIES: 'Credit card liabilities retrieved ',
    BANK_PURPOSE_ATTACHED: 'Bank purpose attached successfully.',
    BANK_PURPOSE_EDITED: 'Bank purpose edited successfully.',
    PURPOSE_LIST: 'Bank purpose fetched successfully.',
  },
  MENU: {
    CREATE_MENU: 'Menu Created successfully',
    REARRANGE_MENU: 'Menu Rearrange successfully',
    UPDATE_MENU: 'Menu Updated successfully',
    CREATE_CATEGORY: 'Category saved successfully',
    CREATE_ITEM: 'Item saved successfully',
    CREATE_MODIFIER_OPTION: 'ModiferOption saved successfully',
    CREATE_MODIFIER_GROUP: 'ModiferGroup saved successfully',
    CREATE_MODIFIER: 'Modifer saved successfully',
    CREATE_TAG: 'Tag saved successfully',
    CREATE_ALLERGEN: 'Allergen saved successfully',
    GET_ITEM: 'Item retrieved successfully',
    GET_ALLERGEN: 'Allergen retrieved successfully',
    GET_TAG: 'Tag retrieved successfully',
    GET_MENU: `Menu retrieved successfully`,
    GET_CACHED_MENU: `Cached menu retrieved successfully`,
    REMOVE_MENU: `Menu removed successfully`,
    GET_MENU_LIST: `Menu's retrieved successfully`,
    GET_TOP_ITEMS: `Top Items retrieved successfully`,
    GET_FAVORITE_ITEMS: `Favorite retrieved successfully`,
    GET_CATEGORY_ITEMS: `Category Items retrieved successfully`,
    GET_ITEM_MODIFIER_GROUPS: `Item modifier groups retrieved successfully`,
    VALID_MENU_VERSION: 'Menu is up to date',
  },
  LOST_AND_FOUND: {
    CREATE_ITEM: `Item sucessfully added.`,
    GET_ALL_ITEMS: 'Items retrieved Successfully',
    GET_ITEM_BY_ID: 'Item fetched Sucessfully',
    UPDATE_ITEM: 'Item updated Successfully',
    DELETE_ITEM: 'Item deleted successfully',
  },
  CATEGORY: {
    CREATE_CATEGORY: 'Category Created successfully',
    UPDATE_CATEGORY: 'Category Updated successfully',
    GET_CATEGORY: `Category retrieved successfully`,
    GET_CATEGORY_LIST: 'Categories retrieved successfully',
    REMOVE_CATEGORY: `Category removed successfully`,
    REARRANGE_CATEGORY: 'Categories Rearranged successfully',
  },
  MODIFIER: {
    CREATE_MODIFIER: 'Modifier Created successfully',
    UPDATE_MODIFIER: 'Modifier Updated successfully',
    GET_MODIFIER: `Modifier retrieved successfully`,
    GET_MODIFIER_LIST: 'Modifiers retrieved successfully',
    REMOVE_MODIFIER: `Modifier removed successfully`,
  },
  MODIFIER_OPTIONS: {
    CREATE_MODIFIER_OPTION: 'ModifierOption Created successfully',
    UPDATE_MODIFIER_OPTION: 'ModifierOption Updated successfully',
    GET_MODIFIER_OPTION: `ModifierOption retrieved successfully`,
    GET_MODIFIER_OPTION_LIST: 'ModifierOption retrieved successfully',
    REMOVE_MODIFIER_OPTION: `ModifierOption removed successfully`,
  },
  TAG: {
    REMOVE_TAG: `TAG removed successfully`,
    TAGS_ALLERGENS_FETCH: `Customer tags and allergens fetch successfully`,
  },
  ITEM: {
    REMOVE_ITEM: `Item removed successfully`,
    GET_ITEM: 'Item retrieved successfully',
    UPDATE_ITEM: 'Item updated successfully',
    CREATE_ITEM: 'Item created successfully',
    GET_ITEMS: 'Items retrieved successfully',
  },
  RESTAURANT_REVIEW: {
    CREATED: 'Restaurant Review Added Successfully',
    FETCHED: 'Restaurant Review fetched Successfully',
    UPDATED: 'Restaurant Review updated Successfully',
    RESPONDED: 'Restaurant Review responded Successfully',
  },
  CUSTOMER: {
    CREATE_CUSTOMER: 'Customer Created successfully',
    GET_CUSTOMERS: `Customers retrieved successfully`,
    UPDATE_CUSTOMER: `Customer updated successfully`,
    ALREADY_EXIST_EMAIL: 'Customer with this email address already exists',
    ALREADY_EXIST_PHONE: 'Customer with this phone number already exists',
    SMART_PANEL_FETCHED: 'Customer smart panel fetched successfully',
    ORDER_SOURCES: 'Guestbook order sources fetched successfully',
    GET_CUSTOMER: `Customer retrieved successfully`,
  },
  GUEST: {
    CREATE_GUEST: 'Guest created successfully',
    GET_GUESTS: `Guests retrieved successfully`,
    UPDATE_GUEST: `Guest updated successfully`,
    CREATE_GUEST_SEGMENT: 'Guest segment Created successfully',
    GET_GUEST_SEGMENTS: `Guest segments retrieved successfully`,
    UPDATE_GUEST_SEGMENTS: `Guest segments updated successfully`,
    GET_GUESTS_ORDERS: `Guest orders retrieved successfully`,
    ALREADY_EXIST_EMAIL: 'Guest with this email address already exists',
    ALREADY_EXIST_PHONE: 'Guest with this phone number already exists',
  },
  SPOTLIGHT: {
    CREATE_SPOTLIGHT: 'Spotlights created successfully',
    GET_SPOTLIGHTS: 'Spotlights retrieved successfully',
    UPDATE_SPOTLIGHT: `Spotlights updated successfully`,
  },
  JOURNEY: {
    GET_CUSTOMERS: `Journey customers retrieved successfully`,
    GET_JOURNEYS: `Journeys retrieved successfully`,
    UPDATE_JOURNEY: `Journey updated successfully`,
    UPDATE_JOURNEY_STATUS: (isEnabled: boolean) => `Journey ${isEnabled ? 'enabled' : 'disabled'} successfully`,
  },
  CATERING: {
    CATERING_ORDER: {
      GET: 'Catering orders fetched successfully',
      DASHBOARD_STATS: 'Catering dashboard fetched successfully',
      KDS_ORDERS: 'KDS catering orders fetched successfully',
      SEND_TO_KDS: 'Catering order sent to KDS successfully',
      SCHEDULE_TO_KDS: 'Catering order scheduled to KDS successfully',
      KDS_CONFIG_SAVE: "Catering order's KDS config saved successfully",
      KDS_FULFILL: "Catering order's KDS fulfilled successfully",
      UPDATE_STATUS: 'Catering order status updated successfully',
      GET_BY_ID: 'Catering order fetched successfully',
      GET_STATS: 'Catering order stats fetched successfully',
      CREATE: 'Catering order created successfully',
      UPDATE: 'Catering order updated successfully',
      NO_ORDERS_FOUND: 'No catering orders found',
      GET_ORDER_SLUGS: 'Catering order slugs fetched successfully',
      CREATE_TODO_TASK: 'Todo task created successfully',
      UPDATE_TODO_TASK_STATUS: 'Todo task status updated successfully',
      DELETE_TODO_TASK: 'Todo task deleted successfully',
      UPDATE_TODO_TASK: 'Todo task updated successfully',
      REVIEW_CREATED: 'Order review created successfully',
      REVIEW_UPDATED: 'Order review updated successfully',
      UPDATE_ORDER_ASSIGNEE: 'Order assignee updated successfully',
    },
    CATERING_INVOICE: {
      GET: 'Catering invoices fetched successfully',
      CREATE: 'Catering invoice created successfully',
      RESEND_EMAIL: 'Catering invoice email resent successfully',
      UPDATE: 'Catering invoice updated successfully',
      GET_STATS: 'Catering invoice stats fetched successfully',
      GET_INVOICE_PDF: 'Catering invoice pdf fetched successfully',
      SEND_EMAIL: 'Catering invoice email sent successfully',
    },
    CATERING_PACKAGE: {
      GET: 'Catering packages fetched successfully',
      CREATE: 'Catering package created successfully',
      UPDATE: 'Catering package updated successfully',
      DELETE: 'Catering package deleted successfully',
      ALREADY_DELETED: 'Catering package already deleted',
      GET_BY_ID: 'Catering package fetched successfully',
      LIST_ALL_PACKAGES: 'Catering packages fetched successfully',
      CHANGE_STATUS: 'Catering package status changed successfully',
      NO_PACKAGES_FOUND: 'No catering packages found',
    },
    CATERING_EMAIL_NOTE: {
      CREATE: 'Catering email note created successfully',
      LIST: 'Catering email notes fetched successfully',
      NO_NOTES_FOUND: 'No catering email notes found',
    },
    CATERING_EMAIL_TEMPLATE: {
      CREATE: 'Catering email template created successfully',
      LIST: 'Catering email templates fetched successfully',
      GET: 'Catering email template fetched successfully',
      NO_TEMPLATES_FOUND: 'No catering email templates found',
      NOT_FOUND: 'Catering email template not found',
      UPDATE: 'Catering email template updated successfully',
    },
    EMAIL_INBOX: {
      GET: 'Catering email inbox fetched successfully',
      SEND: 'Catering email sent successfully',
      LINK_THREAD_TO_ORDER: 'Catering thread linked to order successfully',
      MARK_MESSAGE_AS_READ: 'Catering message marked as read successfully',
      THREAD_MARKED_AS_STARRED: 'Thread marked as starred successfully',
      THREAD_UNSTARRED: 'Thread unstarred successfully',
    },
  },
  REVIEW_MANAGMENT: {
    SUMMARIES: {
      GENERATE: 'Successfully generated summaries',
    },
    TOPICS: {
      GENERATE: 'Successfully generated topics',
    },
    ASPECT: {
      GENERATE: 'Successfully generated aspects',
    },

    CONFIGURATION: {
      GET_CONFIGURATIONS: `Review configurations retrieved successfully`,
      UPDATE_CONFIGURATIONs: `Review configurations updated successfully`,
    },

    REVIEW: {
      REVIEWS: 'Reviews fetched successfully',
      OVERVIEW: 'Overview fetched successfully',
      SENTIMENT_OVERVIEW: 'Sentiment overview fetched successfully',
      SUMMARIES: 'Summaries fetched successfully',
      RECOMMENDATIONS: 'Recommendations fetched successfully',
      URL: 'Review urls fetched successfully',
      SCRAPPER: 'Scrapper source added successfully',
      SOURCES: 'Review sources fetched successfully',
      DELETE_SCRAPPER: 'Scrapper removed source added successfully',
      TOPICS: 'Review topics fetched successfully',
      READ: 'Review read successfully',
      DELETE_REPLY: 'Review reply deleted successfully',
      REPLY: 'Reply posted successfully',
      REPLY_FETCHED: 'Reply fetched successfully',
      TICKET_DETAILS: 'Ticket details fetched successfully',
    },
  },
  INTEGERATION: {
    GET_INTEGRATIONS: `Integrations fetched successfully`,
    TRIPADVISOR_SEARCH: `Tripadvisor locations fetched successfully`,
    CONNECT_TRIPADVISOR: `Tripadvisor account connected successfully`,
    DISCONNECT_TRIPADVISOR: `Tripadvisor account disconnected successfully`,
    CONNECT_GOOGLE: `Google account connected successfully`,
    DISCONNECT_GOOGLE: `Google account disconnected successfully`,
    CONNECT_TIKTOK: `TikTok account connected successfully`,
    DISCONNECT_TIKTOK: `TikTok account disconnected successfully`,
    CONNECT_YELP: `Yelp account connected successfully`,
    DISCONNECT_YELP: `Yelp account disconnected successfully`,
    CONNECT_FACEBOOK: `Facebook account connected successfully`,
    DISCONNECT_FACEBOOK: `Facebook account disconnected successfully`,
    CONNECT_INSTAGRAM: `Instagram account connected successfully`,
    DISCONNECT_INSTAGRAM: `Instagram account disconnected successfully`,
    INSTAGRAM_PAGES: `Instagram pages fetched successfully`,
    FACEBOOK_PAGES: `Facebook pages fetched successfully`,
    META_PAGES: `Meta pages fetched successfully`,
    TIKTOK_CREATOR: 'TikTok creator fetched successfully',
    YELP_PROFILE: 'Yelp profile fetched successfully',
    REVIEWS_FETCHED: 'Reviews fetched successfully',
    ACCOUNTS_INFO_FETCHED: 'Account information fetched successfully',
    LOCATIONS_FETCHED: 'Locations fetched successfully',
    LOCATION_EXISTS: 'Google location exists',
    LOCATION_NOT_EXISTS: 'Google location does not exists',
    REFRESH_TOKEN_EXPIRED: 'Refresh token expired, please reconnect google account',
    YELP_STORE_BUSINESS: 'Yelp business stored successfully',
    BUSINESS_EXISTS: 'Yelp business exists',
    BUSINESS_NOT_EXISTS: 'Yelp business does not exists',
  },
  GOOGLE_SEARCH_CONSOLE: {
    SITE_VERIFICATION_TOKEN: 'Google Search Console site verification token generated successfully',
    VERIFY_SITE: 'Site verified in Google Search Console successfully',
    ADD_SITE: 'Site added to Google Search Console successfully',
    SUBMIT_SITEMAP: 'Sitemap submitted to Google Search Console successfully',
    GET_SITEMAPS: 'Sitemaps fetched from Google Search Console successfully',
  },
  DEAL: {
    CREATE_DEAL: 'Deal created successfully',
    CREATE_DEAL_STEP: (step: number) => `Deal step ${step} successfully`,
    GET_DEALS: `Deals retrieved successfully`,
    UPDATE_DEAL: `Deal updated successfully`,
    ARCHIVE_DEAL: `Deal archived successfully`,
    END_DEAL: `Deal ended successfully`,
    REMOVE_DEAL: 'Deal removed successfully',
    DEAL_APPLIED: 'Deal applied successfully',
  },
  STORAGE_AREA: {
    REMOVE_STORAGE_AREA: `Storage Area removed successfully`,
    GET_STORAGE_AREA: 'Storage Area retrieved successfully',
    UPDATE_STORAGE_AREA: 'Storage Area updated successfully',
    CREATE_STORAGE_AREA: 'Storage Area created successfully',
  },
  CAMPAIGN: {
    CREATE_CAMPAIGN: 'Campaign created successfully',
    CREATE_CAMPAIGN_STEP: (step: number) => `Campaign step ${step} successfully`,
    GET_CAMPAIGNS: `Campaigns retrieved successfully`,
    UPDATE_CAMPAIGN: `Campaign updated successfully`,
    ARCHIVE_CAMPAIGN: `Campaign archived successfully`,
    END_CAMPAIGN: `Campaign ended successfully`,
  },

  TICKET: {
    CREATE_TICKET: 'Ticket Created successfully',
    GET_TICKET: `Ticket retrieved successfully`,
    CREATE_TICKET_ID: 'Ticket Id Created successfully',
    EDIT_TICKET: 'Ticket Edited successfully',
    GET_TICKET_DETAILS: `Ticket Details retrieved successfully`,
    GET_UNCLOSED_COUNT: `UnClosed Ticket Count retrieved successfully`,
    LOYALTY_APPLIED_SUCCESSFULLY: 'Loyalty Applied Successfully',
    TICKET_FIRED: 'Ticket has fired successfully',
    TICKET_CANCELLED: 'Ticket has cancelled successfully',
    TICKET_REFUNDED: 'Ticket has refunded successfully',
    TICKET_NOT_FOUND: 'No Pending Tickets Found',
  },

  GUEST_HELP_REQUEST: {
    CREATE_GUEST_HELP_REQUEST: 'Guest Help Request Created successfully',
    NOTIFY_MANAGER: 'Manager notified successfully',
    GUEST_HELP_REQUEST_UPDATE: 'Guest Help Request updated successfully',
  },

  BRAND_BOOK_CONTENT: {
    UPDATE_CREATE_DELETE_BRAND_BOOK_CONTENT: 'Brand Book Content Created,Updated & Deleted',
    GET_BRAND_BOOK_CONTENT: 'Brand Book Content retrived successfully',
    CREATE_BRAND_BOOK_CONTENT: 'Brand Book Content Created',
  },
  ORDER: {
    GET_Order: 'Order retrieved successfully',
    SCHEDULED_ORDER_VALID_FOR_FIRING: 'Scheduled order is valid for firing',
  },

  TICKET_ITEM: {
    CREATE_TICKET_ITEM: 'Ticket Item Created successfully',
    GET_TICKET_ITEM: `Ticket Item retrieved successfully`,
    DAILY_STAT: 'Daily Stats retrieved successfully',
    ITEM_REMOVED: 'Ticket Item Removed successfully',
  },

  SERVICE_CHARGES: {
    GET_SERVICE_CHARGES: `Service Charges retrieved successfully`,
    UPDATE_SERVICE_CHARGES: `Service Charges updated successfully`,
  },

  SSE: {
    EVENT_SENT: 'Event sent to Device',
  },

  CUSTOM_ITEM: {
    CREATE_CUSTOM_ITEM: 'Custom Item Created successfully',
    GET_CUSTOM_ITEM: `Custom Item retrieved successfully`,
  },
  PAYMENT: {
    CREATE_SERVICE_CHARGE: 'Service Charge Created successfully',
    GET_SERVICE_CHARGE: 'Service Charge retrieved successfully',
    CREATE_PAYMENT: 'Payment Successful',
    CREATE_REFUND: 'Refund Successful',
    CREATE_CARD_PAYMENT_TRIGGER_LOG: 'Card Payment Trigger Log Created successfully',
    GET_PAYMENT: 'Payment retrieved successfully',
    GET_REFUND: 'Refund retrieved successfully',
    PAYMENT_INTENT_CREATED: 'Payment Intent Created successfully',
    PAYMENT_INTENT_CAPTURED: 'Payment Intent Captured successfully',
    PAYMENT_INTENT_CANCELED: 'Payment Intent Canceled successfully',
    PAYMENT_INTENT_UPDATED: 'Payment Intent Updated successfully',
    CONNECTION_TOKEN_CREATED: 'Connection Token Created successfully',
    PAYMENT_INTENT_INCREMENTED: 'Payment Intent Incrementd successfully',
    PAYMENT_ADJUSTED: 'Payment Adjusted successfully',
    PAYMENT_AUTHORIZED: 'Payment Authorized Successfully',
  },

  SALES_TAX: {
    CREATE_SALES_TAX: 'SalesTax Created successfully',
    UPDATE_SALES_TAX: 'SalesTax Updated successfully',
    GET_SALES_TAX: `SalesTax retrieved successfully`,
    GET_SALES_TAX_LIST: 'SalesTax retrieved successfully',
    REMOVE_SALES_TAX: `SalesTax removed successfully`,
  },

  OPERATIONS: {
    CREATE_OPERATION_USER: 'Operation User Created successfully',
    UPDATE_OPERATION_USER: 'Operation User Updated successfully',
    GET_OPERATION_USER: `Operation User retrieved successfully`,
    GET_OPERATION_USER_LIST: 'Operation User retrieved successfully',
    REMOVE_OPERATION_USER: `Operation User removed successfully`,
  },

  AIO_BUDDY: {
    CREATE_AIO_BUDDY_USER: 'Aio Buddy User Created successfully',
    UPDATE_AIO_BUDDY_USER: 'Aio Buddy User Updated successfully',
    GET_AIO_BUDDY_USER: `Aio Buddy User retrieved successfully`,
    GET_AIO_BUDDY_USER_LIST: 'Aio Buddy User retrieved successfully',
    REMOVE_AIO_BUDDY_USER: `Aio Buddy User removed successfully`,
  },

  TENDER: {
    CREATE_TENDER: 'Tender Created successfully',
    UPDATE_TENDER: 'Tender Updated successfully',
    GET_TENDER: `Tender retrieved successfully`,
    GET_TENDER_LIST: 'Tender retrieved successfully',
    REMOVE_TENDER: `Tender removed successfully`,
    CREATE_USER_TENDER_LOG: `User tender log created successfully`,
    GET_USER_TENDER_LOG_LIST: `User tender log retrieved successfully`,
  },
  TABLE: {
    CREATE_TABLE: 'Table Created successfully',
    UPDATE_TABLE: 'Table Updated successfully',
    GET_TABLE_LIST: 'Tables retrieved successfully',
    GET_TABLE: 'Table retrieved successfully',
    CHANGE_TABLE: 'Table Changed successfully',
    FREE_TABLE: 'Table freed successfully',
    RESERVE_TABLE: 'Table reserve successfully',
    DELETE_TABLE: 'Table can be deleted',
    ASSIGN_TABLE: 'Table assigned SucessFully',
  },
  FLOOR: {
    GET_FLOOR: 'Floor retrieved successfully',
    CREATE_FLOOR: 'Floor created Successfully',
    DELETE_FLOOR: 'Floor Deleted Successfully',
  },
  AUTHENTICATION: {
    GET_USER: 'user retrieved successfully',
    USER_DOESNT_EXIST: "User doesn't exist",
    SIGN_UP: 'user created successfully',
    SEND_OTP: 'OTP sent successfully',
    VERIFY_OTP: 'OTP verified successfully',
    UPDATE_PASSWORD: 'password updated successfully',
    LOGIN_USER: 'login successful',
    REFRESH_TOKEN: 'tokens regenerated successfully',
    SET_USER_ATTRIBUTES: 'user attributes set successfully',
    RESEND_EMAIL_VERIFICATION_LINK: 'email verification link resent successfully',
    EMAIL_ATTR_VERIFICATION: 'email verification successful',
    TOKEN_GENERATED: 'token generated successfully',
    CHANGE_PASSWORD: 'password changed successfully',
    DEACTIVATE_ACCOUNT: 'account deactivated successfully',
    VERIFY_MFA_CODE: 'MFA code verified successfully',
    VERIFY_2FA_CODE: '2FA code verified successfully',
    ATTRIBUTE_VERIFIED: 'email/phone_number verified successfully',
    TOGGLE_MFA: 'MFA toggled successfully',
    LOGIN_WITH_POS_PIN: 'login with pos pin successful',
    LOGOUT: 'logout successfull',
    APPROVER_POS_PIN: 'approver pos pin successful',
    FORGOT_PASSWORD: 'otp sent successfully',
    LOGIN_ALLOWED: 'Login permission has been granted',
    ENABLE2FA: 'multi-factor authentication enabled',
    DISABLE2FA: 'multi-factor authentication disabled',
    INVALID_SESSION: 'Invalid session for the user.',
    ENABLE_EMAIL_2FA: '2FA enabled successfully',
    DISABLE_EMAIL_2FA: '2FA disabled successfully',
    ENABLE_2FA_USER: '2FA enabled for superadmin and operation successfully',
    FORGOT_PASSWORD_EMAIL: 'Forgot password email sent successfully',
    FORGOT_PASSWORD_OTP: 'Forgot password otp verification successful',
  },
  USER: {
    IMAGE_UPLOAD: 'Image uploaded successfully',
    IMAGE_DELETE: 'Image deleted successfully',
  },
  SERVER: {
    CREATE_SERVER: 'Server Created successfully',
    GET_SERVER: `Server retrieved successfully`,
    ALREADY_EXIST_EMAIL: 'Server with this email address already exists',
    ALREADY_EXIST_PHONE: 'Server with this phone number already exists',
    CHANGE_SERVER: 'Server Changed successfully',
    ASSIGN_SERVER: 'Server Assigned successfully',
  },
  RESTAURANT: {
    CREATE_RESTAURANT: 'Restaurant created successfully',
    GET_RESTAURANT: 'Restaurants retrieved successfully',
    GET_RESTAURANT_BY_ID: 'Restaurant retrieved successfully',
    UPDATE_RESTAURANT: 'Restaurant updated successfully',
    UPDATE_KDS: 'KDS updated successfully',
    UPDATE_STATION: 'Station updated successfully',
    GET_STATIONS: 'Station retrieved successfully',
    CREATE_MAPPING: 'Item linked with Station successfully',
    UPDATE_MAPPING: 'Mapping updated successfully',
    GET_MAPPING: 'Successfully retrieved mapping.',
    GET_FAVOURITE_ITEMS: 'Successfully retrieved Favorite Items.',
    GET_RESTAURANT_TIMINGS: 'Restaurant timings retrieved successfully',
    CREATE_RESTAURANT_TIMING: 'Restaurant timing created successfully',
    CLOSE_OUT: 'Close Out Successfull',
    OPEN_UP: 'Restaurant open Successfully',
    ALREADY_OPENED_UP: 'Restaurant already opened',
    DELETE_RESTAURANT: 'Restaurant Deleted Successfully',
    KDS_SERVER_CALL: 'Call to server sent successfully',
    UPDATE_TAX_INCLUSIVE: 'Tax inclusive value updated successfully',
  },
  EMPLOYEE: {
    REVIEW_ADDED: 'Review Added Successfully',
    POS_PIN_UPDATED: 'Pos Pin Updated successfully',
    EMPLOYEES_FETCHED: 'Employees fetched successfully',
    EMPLOYEE_FETCHED: 'Employee fetched successfully',
    EMPLOYEE_EMAIL_UPDATED: 'Employee email updated successfully',
    CREATE_EMPLOYEE: 'Employee created successfully',
    UPDATE_EMPLOYEE: 'Employee updated successfully',
    DELETE_EMPLOYEE: 'Employee deleted successfully',
    EMPLOYEE_DATA: 'Error while getting employee data',
    ACTIVE_EMPLOYEE: 'Employee status has been changed to active',
    DEACTIVATE_EMPLOYEE: 'Employee status has been changed to de-active',
    REINVITE_EMPLOYEE: 'Employee has been re invited successfully',
  },
  ONBOARDING_DOCUMENTS: {
    ONBOARDING_DOCUMENTS_CREATED: 'Onboarding Documents created successfully',
    ONBOARDING_DOCUMENTS_FETCHED: 'Onboarding Documents fetched successfully',
    ONBOARDING_DOCUMENTS_UPDATED: 'Onboarding Documents updated successfully',
    ONBOARDING_DOCUMENTS_DELETED: 'Onboarding Documents deleted successfully',
  },
  EMPLOYEE_DOCUMENTS: {
    EMPLOYEE_DOCUMENTS_CREATED: 'Employee Documents created successfully',
    EMPLOYEE_DOCUMENTS_FETCHED: 'Employee Documents fetched successfully',
    EMPLOYEE_DOCUMENTS_UPDATED: 'Employee Documents updated successfully',
    EMPLOYEE_DOCUMENTS_DELETED: 'Employee Documents deleted successfully',
  },
  CART_ITEM: {
    CREATE_CART_ITEM: 'Cart Item created successfully',
    UPDATE_CART_ITEM: 'Cart Item updated successfully',
    DELETE_CART_ITEM: 'Cart Item deleted successfully',
  },
  CART: {
    CREATE_CART: 'Cart created successfully',
    GET_CART: 'Cart retrieved successfully',
    UPDATE_CART: 'Cart updated successfully',
    CHECKOUT_CART: 'Cart checked out successfully',
    GET_CARTS_BY_ORDERID: 'Cart retrieved successfully by Order ID',
  },
  FEED_BACK: {
    ITEM_REVIEW: 'Review Addded to item Successfully',
    GET_ITEM_REVIEW: 'Item Review fetched Successfully',
    LIKE_ITEM: 'Item Liked Successfully',
    DISLIKE_ITEM: 'Item Disliked Successfully',
    GET_ITEM_Like: 'Item likes fetched Successfully',
    NUGGET_REVIEW: 'Review from Nugget added successfully',
  },
  DEVICE_SETTINGS: {
    FETCHED: 'Device Settings fetched successfully',
    DELETED: 'Device Settings deleted successfully',
    CREATED: 'Device Settings created successfully',
  },
  GENERAL_SETTINGS: {
    FETCHED: 'General Settings fetched successfully',
    DELETED: 'General Settings deleted successfully',
    CREATED: 'General Settings created successfully',
    UPDATED: 'General Settings updated successfully',
  },
  CASH_DRAWER: {
    CREATE_CASH_DRAWER: 'Cash Drawer created successfully',
    ADJUST_STARTING_BALANCE: 'Starting balance adjusted successfully',
    FETCH_CASH_DRAWERS: 'Cash Drawers fetched successfully',
    GET_CASH_DRAWER: 'Cash drawer fetched successfully',
    DELETE_CASH_DRAWER: 'Cash drawer deleted successfully',
    UPDATE_CASH_DRAWER: 'Cash drawer updated successfully',
    GET_CASH_DRAWER_BY_ID: 'Cash drawer fetched by id successfully',
    POS_DEVICE_ALREADY_USE: 'This POS device is already linked with cash drawer.',
    EMPLOYEE_ASSIGNED: 'Employee has been assigned successfully',
    GET_ASSIGNED_EMPLOYEES: 'Assigned Employees fetched successfully',
    EMPLOYEE_UNASSIGNED: 'Employee unassigned successfully',
  },
  CASH_DRAWER_LOGS: {
    CREATE_CASH_LOG: 'Cash Log created successfully',
    CLOSE_CASH_DRAWER: 'Cash drawer closed successfully',
    CLOSE_HOUSE_AND_CASH_DRAWER: 'Cash drawer along with House drawer closed successfully',
    OPEN_AFTER_AUTO_CLOSE_OUT: 'Opening After Auto Close Out',
    OPEN_AFTER_MANUAL_CLOSE_OUT: 'Opening After Manual Close Out',
    CASH_LOGS_FETCHED_SUCCESSFULLY: 'Cash Logs fetched successfully',
  },
  BREAKS: {
    BREAK_CREATED: 'Break created successfully',
    BREAK_FETCHED: 'Break fetched successfully',
    BREAK_UPDATED: 'Break updated successfully',
    BREAK_DELETED: 'Break deleted successfully',
    MISSED_BREAKS_FETCHED: 'Missed breaks fetched successfully',
    BREAK_LOGGED: 'Break logged successfully',
  },
  PAYROLL: {
    PAYROLL_CREATED: 'Payroll created successfully',
    PAYROLL_FETCHED: 'Payroll fetched successfully',
    PAYROLL_DELETED: 'Payroll deleted successfully',
  },
  ROLE: {
    ROLE_CREATED: 'Role created successfully',
    ROLE_FETCHED: 'Role fetched successfully',
    ROLE_UPDATED: 'Role updated successfully',
    ROLE_DELETED: 'Role deleted successfully',
  },
  TIME_LOG: {
    CLOCKED_IN: 'Clocked in successfully',
    CLOCKED_OUT: 'Clocked out successfully',
    BREAK_STARTED: 'Break started successfully',
    BREAK_ENDED: 'Break ended successfully',
    GET_TIME_DATA: 'Time data fetched successfully',
    GET_MANAGER_DASHBOARD_DATA: 'Manager dashboard data fetched successfully',
    GET_Z_REPORT_COMPLETE_STATUS: 'Z report complete status fetched successfully',
    GET_Z_REPORT: 'Z report fetched successfully',
    GET_TIME_CARDS: 'Time cards fetched successfully',
    GET_SUMMARY: 'Summary fetched successfully',
    EXPORT_TIMECARDS: 'Time cards exported successfully',
    UPDATE_TIME_CARD: 'Shift Time Updated',
  },
  TIME_OFF: {
    TIMEOFF_REQUEST_CREATED: 'Timeoff requested successfully',
    GET_TIMEOFF_REQUEST_BY_ID: 'Time off request fetched successfully',
    GET_TIMEOFF_REQUESTS_BY_RESTAURANT_ID: 'Time off requests fetched successfully',
    UPDATE_TIME_OFF_REQUEST: 'Time off request updated successfully',
    EDIT_TIME_OFF_REQUEST: 'Time off edited successfully',
    DELETE_TIME_OFF_REQUEST: 'Time off deleted successfully',
  },
  TIMEOFF: {
    LEAVE_OVERVIEW_FETCHED: 'Leave overview fetched successfully',
    LEAVE_OVERVIEW_UPDATED: 'Leave overview updated successfully',
    POLICY_CREATED: 'Policy created successfully',
    POLICY_FETCHED: 'Policy fetched successfully',
    POLICIES_FETCHED: 'Policies fetched successfully',
    POLICY_UPDATED: 'Policy updated successfully',
    POLICY_DELETED: 'Policy deleted successfully',
    POLICY_STATUS_CHANGED: 'Policy status changed successfully',
    POLICY_DUPLICATED: 'Policy duplicated successfully',
    USER_RESTAURANT_POLICY_CREATED: 'User restaurant policy created successfully',
    USER_RESTAURANT_POLICIES_FETCHED: 'User restaurant policies fetched successfully',
    USER_RESTAURANT_POLICY_DELETED: 'User restaurant policy deleted successfully',
  },
  TASKS: {
    TASK_CREATED: 'Task created successfully',
    GET_TASKS: 'Tasks fetched successfully',
    GET_TASK_BY_ID: 'Task fetched successfully',
    UPDATE_TASK: 'Task updated successfully',
    COMPLETE_TASK_WITH_PHOTO: 'Task completed successfully with photo',
    COMPLETE_TASK_WITH_NUMERIC: 'Task completed successfully with numeric value',
    COMPLETE_TASK_WITH_TEMPERATURE: 'Task completed successfully with temperature',
    GET_TASK_HISTORY: 'Task history fetched successfully',
    UPLOAD_IMAGE: 'Image uploaded successfully',
    DELETE_TASK: 'Task Deleted Successfully',
  },
  VAULT_CATEGORY: {
    VAULT_CATEGORY_REQUEST_CREATED: 'Vault Category created successfully',
    VAULT_CATEGORY_REQUEST_BY_ID: 'Vault Category request fetched successfully',
    VAULT_CATEGORY_REQUESTS_BY_RESTAURANT_ID: 'Vault Category requests fetched successfully',
    UPDATE_VAULT_CATEGORY_REQUEST: 'Vault Category request updated successfully',
  },
  VAULT_CATEGORY_ITEM: {
    VAULT_CATEGORY_ITEM__CREATED: 'Vault Category Item created successfully',
    VAULT_CATEGORY_ITEM_REQUEST_BY_ID: 'Vault Category Item fetched successfully',
    VAULT_CATEGORY_ITEM_REQUEST_BY_PARENT_FOLDER: 'Vault Category Items fetched successfully',
    UPDATE_VAULT_CATEGORY_ITEM_REQUEST: 'Vault Category Item updated successfully',
    DELETE_VAULT_CATEGORY_ITEM: 'Vault Category Item deleted successfully',
    GET_VAULT_STATS: 'Vault Stats fetched successfully',
  },
  REPORTS: {
    GET_REPORTS_OVERVIEW: 'Reports fetch successfully',
    GET_DEFAULT_START_END_DATE: 'Default start end date fetched successfully',
    GET_EMPLOYEE_PRODUCTIVITY_SUMMARY_REPORT: 'Employee Productivity Summary Report fetched successfully',
    GET_FOH_SUMMARY_REPORT: 'FOH Staff Summary Report fetched successfully',
    GET_BOH_SUMMARY_REPORT: 'BOH Staff Summary Report fetched successfully',
    GET_REVENUE_CENTER_REPORT: 'Revenue Center Report fetched successfully',
    GET_ORDER_SOURCE_REPORT: 'Order Source Report fetched successfully',
    GET_SALES_BY_CATEGORY_REPORT: 'Sales by Category Report fetched successfully',
    GET_SALES_TREND: 'Sales trend fetched successfully',
    PAYMENT_REVENUE_TIPS: 'Payment revenue tips fetched successfully',
    VOID_SURCHARGE_DISCOUNT: 'Void surcharge discount fetched successfully',
    ORDER_TYPE_TAX: 'Order type tax fetched successfully',
    EMPLOYEE_DATA: 'Employee data fetched successfully',
    NET_SALES_BREAKDOWN_DATA: 'Net sales break down data fetched successfully',
    GET_REFUND_SUMMARY_REPORT: 'Refund Summary Report fetched successfully',
    GET_GIFT_CARD_SUMMARY_REPORT: 'Gift Card Summary Report fetched successfully',
    GET_CATERING_SUMMARY_REPORT: 'Catering Summary Report fetched successfully',
    GET_BREAK_COMPLIANCE_SUMMARY: 'Break compliance summary report retrieved successfully',
    GET_BREAK_COMPLIANCE_BY_ROLE: 'Break compliance by role retrieved successfully',
    GET_BREAK_COMPLIANCE_BY_TIME: 'Break compliance by time retrieved successfully',
    GET_LABOR_COST_V2_SUMMARY: 'Labor cost v2 summary fetched successfully',
    GET_LABOR_COST_V2_DATA: 'Labor cost v2 data fetched successfully',
    GET_OVERTIME_V2_SUMMARY: 'Overtime v2 summary fetched successfully',
    GET_OVERTIME_V2_DATA: 'Overtime v2 data fetched successfully',
    GET_TIPS_REPORT_BY_DAY: 'Tips report by day fetched successfully',
    GET_LOYALTY_SUMMARY_REPORT: 'Loyalty summary report fetched successfully',
    GET_DEALS_SUMMARY_REPORT: 'Deals summary report fetched successfully',
    GET_DEALS_PERFORMANCE: 'Deals performance fetched successfully',
    GET_DISCOUNT_SUMMARY: 'Discount summary fetched successfully',
    GET_DISCOUNT_DATA: 'Discount data fetched successfully',
    GET_DISCOUNT_BY_TYPE: 'Discount by type fetched successfully',
    GET_EMPLOYEE_DISCOUNT_BREAKDOWN: 'Employee discount breakdown fetched successfully',
  },
  POS_DASHBOARD: {
    MY_DAY: 'My Day analytics fetched successfully',
    OVERVIEW: 'Overview analytics fetched successfully',
  },
  ONLINE_ORDERING_SETTINGS: {
    FETCHED: 'Online Ordering Settings fetched successfully',
    ENABLED: 'Online ordering enabled successfully',
    DELETED: 'Online Ordering Settings deleted successfully',
    CREATED: 'Online Ordering Settings created successfully',
    UPDATED: 'Online Ordering Settings updated successfully',
  },
  ACTIVITY_LOG: {
    ACTIVITY_LOG_FETCHED: 'Activity logs fetched successfully',
  },
  BOOKMARK: {
    BOOKMARK_CREATED: 'Bookmark created successfully',
    BOOKMARK_FETCHED: 'Bookmark fetched successfully',
    BOOKMARK_DELETED: 'Bookmark deleted successfully',
  },
  BUSINESS: {
    BUSINESS_CREATED: 'Business saved Successfully',
    BUSINESS_GET: 'Business retrieved Successfully',
    BUSINESS_UPDATE: 'Business updated Successfully',
    BUSINESS_DELETE: 'Business removed Successfully',
    COMPANY_AND_WORKPLACE_GET: 'Company and workplace retrieved successfully',
  },
  CARD: {
    CARD_CREATED: 'CardInfo saved Successfully',
    CARD_GET: 'Card list retrieved Successfully',
    CARD_UPDATE: 'CardInfo Updated Successfully',
    CARD_DELETE: 'Card Deleted Successfully',
    CARD_RECURRING_PAYMENT: 'Update recurring Payment Successfully',
  },
  BANKACCOUNT: {
    ACCOUNT_CREATED: 'Bank Account Created Successfully',
    ACCOUNT_GET: 'Bank Account retrieved Successfully',
    ACCOUNT_UPDATE: 'Bank Account Updated Successfully',
    ACCOUNT_DELETE: 'Bank Account Deleted Successfully',
  },
  DISCOUNT: {
    FETCHED: 'Discount fetched successfully',
    DELETED: 'Discount deleted successfully',
    CREATED: 'Discount created successfully',
    UPDATED: 'Discount updated successfully',
    CREATE_DISCOUNT: 'Discount Created successfully',
    UPDATE_DISCOUNT: 'Discount Updated successfully',
    GET_DISCOUNT: `Discount retrieved successfully`,
    GET_DISCOUNT_LIST: 'Discounts retrieved successfully',
    REMOVE_DISCOUNT: `Discount removed successfully`,
  },
  TAX: {
    FETCHED: 'Taxes fetched successfully',
    DELETED: 'Taxes deleted successfully',
    CREATED: 'Taxes created successfully',
    UPDATED: 'Taxes updated successfully',
  },
  RESTAURANT_DASHBOARD: {
    DECLARE_AMOUNT_SUCCESSFUL: 'Amount declared successfully',
    GET_AMOUNT_LOGS_SUCCESSFUL: 'Amount logs fetched successfully',
  },
  KDS: {
    GET_KDC: 'KDC fetched successfully',
    UPDATE_KDC: 'KDC updated successfully',
  },
  AUTH_ROLE: {
    CREATE_ROLE: 'Role Created successfully',
    GET_ROLES: `Roles retrieved successfully`,
    UPDATE_ROLE: `Role updated successfully`,
    DELETE_ROLE: `Role deleted successfully`,
    ALREADY_EXIST_ROLE: 'Role with this name already exists',
  },
  MODULE: {
    CREATE_MODULE: 'Module Created successfully',
    GET_MODULES: `Modules retrieved successfully`,
    UPDATE_MODULE: `Module updated successfully`,
    DELETE_MODULE: `Module deleted successfully`,
    ALREADY_EXIST_MODULE: 'Module with this name already exists',
  },
  APP: {
    CREATE_APP: 'App Created successfully',
    GET_APPS: `Apps retrieved successfully`,
    UPDATE_APP: `App updated successfully`,
    DELETE_APP: `App deleted successfully`,
    ALREADY_EXIST_APP: 'App with this name already exists',
  },
  FEATURE: {
    CREATE_FEATURE: 'Feature Created successfully',
    GET_FEATURES: `Features retrieved successfully`,
    UPDATE_FEATURE: `Feature updated successfully`,
    DELETE_FEATURE: `Feature deleted successfully`,
    ALREADY_EXIST_FEATURE: 'Feature with this name already exists',
  },
  ROLE_FEATURE: {
    CREATE_ROLE_FEATURE: 'Role Feature Created successfully',
    GET_ROLE_FEATURES: `Role Features retrieved successfully`,
    UPDATE_ROLE_FEATURE: `Role Feature updated successfully`,
    DELETE_ROLE_FEATURE: `Role Feature deleted successfully`,
    ALREADY_EXIST_ROLE_FEATURE: 'Role Feature with this name already exists',
  },
  USER_ROLE_FEATURE: {
    CREATE_USER_ROLE_FEATURE: 'User Role Feature Created successfully',
    GET_USER_ROLE_FEATURES: `User Role Features retrieved successfully`,
    UPDATE_USER_ROLE_FEATURE: `User Role Feature updated successfully`,
    DELETE_USER_ROLE_FEATURE: `User Role Feature deleted successfully`,
    ALREADY_EXIST_USER_ROLE_FEATURE: 'User Role Feature with this name already exists',
  },
  USER_ROLE: {
    CREATE_USER_ROLE: 'User Role Feature Created successfully',
    GET_USER_ROLES: `User Role Features retrieved successfully`,
    UPDATE_USER_ROLE: `User Role Feature updated successfully`,
    DELETE_USER_ROLE: `User Role Feature deleted successfully`,
    ALREADY_EXIST_USER_ROLE: 'User Role already assigned to Employee',
    DEFAULT_UPDATED: 'Default User Role updated successfully',
  },
  USER_PERMISSION: {
    GET_USER_PERMISSION: `User Permission Features retrieved successfully`,
  },
  APPROVAL: {
    CREATE_APPROVAL: 'Approval Created successfully',
    GET_APPROVALS: `Approval retrieved successfully`,
    UPDATE_APPROVAL: `Approval updated successfully`,
    DELETE_APPROVAL: `Approval deleted successfully`,
    ALREADY_EXIST_APPROVAL: 'Approval with this name already exists',
  },
  UserRestaurants: {
    UserRestaurants_CREATED: 'User Restaurants created successfully',
    UserRestaurants_FETCHED: 'User Restaurants fetched successfully',
    UserRestaurants_UPDATED: 'User Restaurants updated successfully',
    UserRestaurants_DELETED: 'User Restaurants deleted successfully',
    DEFAULT_UPDATED: 'Default User Restaurant updated successfully',
  },
  FILE: {
    FILE_UPLOAD_SUCCESSFULLY: 'File Upload Successfully',
    FILE_UPDATED_SUCCESSFULLY: 'File Updated successfully successfully',
    GET_FILE_SUCCESSFULLY: 'Get File Successfully',
    FILE_DELETED: 'File Deleted Successfully',
    FILES_DELETED: 'Files Deleted Successfully',
    FILE_CATEGORY_UPDATE: 'File Category Updated Successfully',
  },
  FONTS: {
    FONTS_FETCHED: 'Font fetched successfully',
    FONT_CREATED: 'Font created successfully',
  },
  FILE_CATEGORY: {
    FILE_CATEGORY_CREATED: 'File Store Category Created Successfully',
    FILE_CATEGORY_NAME_UPDATED: 'File Store Category Name Updated Successfully',
    ALL_CATEGORIES_FETCHED: 'All File Categories Fetched Successfully',
    DELETED: 'Category deleted successfully',
  },
  DAY_SCHEDULE: {
    DAY_SCHEDULE_GET_BY_ID: 'Get data of day schedule successfully',
    DAY_SCHEDULE_CREATE: 'Create day schedule successfully',
    DAY_SCHEDULE_BULK_CREATE: 'Create day schedule successfully',
    DAY_SCHEDULE_UPDATED: 'Update day schedule successfully',
    DAY_SCHEDULE_DELETE: 'Remove day schedule successfully',
    DAY_SCHEDULE_LOG: 'Successfully retrieved day schedule from Database.',
  },
  SETTING: {
    SETTING_GET_BY_ID: 'Get data of setting successfully',
    SETTING_CREATE: 'Create setting successfully',
    SETTING_BULK_CREATE: 'Create setting successfully',
    SETTING_UPDATED: 'Update setting successfully',
    SETTING_DELETE: 'Remove setting successfully',
    SETTING_LOG: 'Successfully retrieved setting from Database.',
  },
  VISIBILITY_SETTING: {
    VISIBILITY_SETTING_GET_BY_ID: 'Get data of visibility setting successfully',
    VISIBILITY_SETTING_CREATE: 'Create visibility setting successfully',
    VISIBILITY_SETTING_BULK_CREATE: 'Create visibility setting successfully',
    VISIBILITY_SETTING_UPDATED: 'Update visibility setting successfully',
    VISIBILITY_SETTING_DELETE: 'Remove visibility setting successfully',
    VISIBILITY_SETTING_LOG: 'Successfully retrieved visibility setting from Database.',
    VISIBILITY_SETTING_GETTING_ERROR: 'Error while getting visibility setting',
    VISIBILITY_SETTING_CREATING_ERROR: 'Error while creating visibility setting',
    VISIBILITY_SETTING_UPDATING_ERROR: 'Error while updating visibility setting',
    VISIBILITY_SETTING_REMOVING_ERROR: 'Error while removing visibility setting',
  },
  WEBSITE: {
    TEMPLATES_GENERATED: 'Templates Generated',
    FILE_UPLOADED: 'File Uploaded',
    TEMPLATES_DOWNLAODED: 'Templates Downloaded',
    JSON_DATA_READ: 'JSON Data Read',
  },
  WEBSITE_LEADS: {
    CREATED: 'Website Lead Created',
  },
  MODIFIER_GROUP: {
    CREATE_MODIFIER_GROUP: 'Modifier Group Created Successfully',
    UPDATE_MODIFIER_GROUP: 'Modifier Group Updated Successfully',
    GET_MODIFIER_GROUP: `Modifier Group retrieved Successfully`,
    GET_MODIFIER_GROUP_LIST: 'Modifier Group retrieved Successfully',
    REMOVE_MODIFIER_GROUP: `Modifier Group Removed Successfully`,
  },
  SERVICE_CHARGE: {
    CREATE_SERVICE_CHARGE: 'Service charge created successfully',
    UPDATE_SERVICE_CHARGE: 'Service charge updated successfully',
    GET_SERVICE_CHARGE: `Service charge retrieved successfully`,
    GET_SERVICE_CHARGE_LIST: 'Service charge retrieved successfully',
    REMOVE_SERVICE_CHARGE: `Service charge removed successfully`,
  },
  WEB_BUILDER: {
    CREATE_WEB_BUILDER: 'Web Builder data Created Successfully',
    GET_WEB_BUILDER: 'Web Builder data Retrieved Successfully',
    UPDATE_WEB_BUILDER: 'Web Builder data Updated Successfully',
    DELETE_WEB_BUILDER: 'Web Builder data Deleted Successfully',
    PUBLISH_WEB_BUILDER: 'Web Builder data Published Successfully',
    WORKFLOW_STATUS_FOUND: 'Workflow run status found',
  },
  WEBSITE_SEO: {
    GET_SEO_DATA: 'SEO data retrieved successfully',
    UPDATE_SEO_DATA: 'SEO data updated successfully',
    CREATE_SEO_DATA: 'SEO data created successfully',
  },
  WEBSITE_OVERVIEW: {
    GET_GOOGLE_TOKEN: 'Google Token create successfully',
    GET_ANALYTICS_DATA: 'Overview data retrieved successfully',
  },
  MOM_DASHBOARD: {
    SPECIFIC_USER_DASHBOARD: 'Successfully retrieved dashboard data',
  },
  LOYALTY: {
    GET_LOYALTY_ITEM_MENU: `Successfully fetched loyalty items menu`,
  },
  INVENTORY: {
    INVENTORY: {
      INVENTORY_GET_SUCCESS: 'Inventory detail retrieved successfully',
    },
    INGREDIENT: {
      INGREDIENT_GET_SUCCESS: 'Ingredient retrieved successfully',
      INGREDIENT_STORAGE_UNIT_UPDATE_SUCCESS: 'Ingredient storage unit updated successfully',
      CREATE_INGREDIENT_SUCCESS: 'Ingredient created successfully',
      INGREDIENT_UPDATE_SUCCESS: 'Ingredient updated successfully',
      GET_INGREDIENT_LIST_SUCCESS: 'Ingredient retrieved successfully',
      GET_INGREDIENT_LOGS_LIST_SUCCESS: 'Ingredient logs retrieved successfully',
      DELETE_INGREDIENT_SUCCESS: 'Ingredient deleted successfully',
      INGREDIENT_RECIPES_GET_SUCCESS: 'Ingredient recipes retrieved successfully',
      CONVERSION_UPDATE_SUCCESS: 'Ingredient conversion updated successfully',
      CONVERSIONS_FETCH_SUCCESS: 'Ingredient conversions fetched successfully',
    },
    STOCK_ADJUSTMENT: {
      CREATED: 'Stock Adjustment created successfully.',
      UPDATED: 'Stock Adjustment updated successfully.',
      DELETED: 'Stock Adjustment deleted successfully.',
      RETRIEVED: 'Stock Adjustment retrieved successfully.',
      INGREDIENTS_RECIPES_RETRIEVED: 'Storage area ingredients and recipes retrieved successfully.',
      ALL_ADJUSTMENTS_RETRIEVED: 'All stock adjustments retrieved successfully.',
      STORAGE_AREAS: 'Storage areas retrieved successfully',
      ADJUSTMENT_SUBMITTED: 'Submitted Successfully',
    },
    UNIT: {
      UNIT_GET_SUCCESS: 'Unit retrieved successfully',
      CREATE_UNIT_SUCCESS: 'Unit created successfully',
      UNIT_UPDATE_SUCCESS: 'Unit updated successfully',
      GET_UNIT_LIST_SUCCESS: 'Unit retrieved successfully',
      DELETE_UNIT_SUCCESS: 'Unit deleted successfully',
    },
    VENDOR: {
      VENDOR_GET_SUCCESS: 'Vendor retrieved successfully',
      CREATE_VENDOR_SUCCESS: 'created successfully',
      VENDOR_UPDATE_SUCCESS: 'updated successfully',
      GET_VENDOR_LIST_SUCCESS: 'Vendors retrieved successfully',
      DELETE_VENDOR_SUCCESS: 'Vendor deleted successfully',
    },
    ORDER: {
      ORDER_GET_SUCCESS: 'Order retrieved successfully',
      CREATE_ORDER_SUCCESS: 'Order created successfully',
      ORDER_UPDATE_SUCCESS: 'Order updated successfully',
      GET_ORDER_LIST_SUCCESS: 'Orders retrieved successfully',
      DELETE_ORDER_SUCCESS: 'Order deleted successfully',
    },
    ORDER_AND_INVOICES: {
      GET_ORDERS_AND_INVOICES: 'Orders and invoices retrieved successfully',
      INVOICE: 'Invoice retrieved successfully',
    },
    UNIT_CONVERSION: {
      UNIT_CONVERSION_GET_SUCCESS: 'Unit Conversions retrieved successfully',
      CREATE_UNIT_CONVERSION_SUCCESS: 'Unit Conversions created successfully',
      UNIT_CONVERSION_UPDATE_SUCCESS: 'Unit Conversions updated successfully',
      GET_UNIT_CONVERSION_LIST_SUCCESS: 'Unit Conversions retrieved successfully',
      DELETE_UNIT_CONVERSION_SUCCESS: 'Unit Conversions deleted successfully',
    },
    CHART_OF_ACCOUNTS: {
      COA_GET_SUCCESS: 'Chat of accounts retrieved successfully',
      CREATE_COA_SUCCESS: 'Chat of account created successfully',
      INGREDIENT_COA_SUCCESS: 'Chat of account updated successfully',
      GET_COA_LIST_SUCCESS: 'Chat of account retrieved successfully',
      DELETE_COA_SUCCESS: 'Chat of account deleted successfully',
    },
    INVOICE: {
      INVOICE_GET_SUCCESS: 'Invoice retrieved successfully',
      CREATE_INVOICE_SUCCESS: 'Invoice created successfully',
      SUBMIT_INVOICE_SUCCESS: 'Invoice submitted successfully',
      INVOICE_UPDATE_SUCCESS: 'Invoice updated successfully',
      GET_INVOICE_LIST_SUCCESS: 'Invoices retrieved successfully',
      DELETE_INVOICE_SUCCESS: 'Invoice deleted successfully',
      UPDATE_INVOICE_STATUS_SUCCESS: 'Invoice status updated successfully',
    },
    RECIPE: {
      RECIPE_GET_SUCCESS: 'Recipe retrieved successfully',
      CREATE_RECIPE_SUCCESS: 'recipe created successfully',
      RECIPE_UPDATE_SUCCESS: 'recipe updated successfully',
      GET_RECIPE_LIST_SUCCESS: 'Recipes retrieved successfully',
      DELETE_RECIPE_SUCCESS: 'Recipe deleted successfully',
      COST_RECALCULATION_SUCCESS: 'Cost recalculated successfully',
      RECIPE_CATEGORY_SUCCESS: 'Recipe category retrieved successfully',
    },
    WASTAGE_LOG: {
      CREATE_WASTAGE_LOG_SUCCESS: 'Wastage log created successfully',
      GET_WASTAGE_LOGS_LIST_SUCCESS: 'Wastage logs retrieved successfully',
      GET_WASTAGE_LOGS_ITEMS_LIST_SUCCESS: 'Wastage logs items retrieved successfully',
    },
    PREP_LIST: {
      UPDATE_PREP_LIST_TO_MAKE: 'To Make values updated successfully',
      GET_PREP_LIST_ITEMS: 'Prep List items retrieved successfully',
      DUPLICATE_PREP_LIST_ITEM: 'Prep List item duplicated successfully',
    },
    COMMON: {
      ROWS_RE_ARRANGE_SUCCESS: 'Rows rearranged successfully.',
    },
  },
  DOMAIN_SETTINGS: {
    GET_DOMAIN_SETTINGS: 'Domain settings retrieved successfully',
    UPDATE_DOMAIN_SETTINGS: 'Domain settings updated successfully',
    CREATE_DOMAIN_SETTINGS: 'Domain settings created successfully',
    DOMAIN_IS_VERIFIED: 'Domain is verified',
    SSL_IS_VALID: 'SSL is valid',
    DOMAIN_DELETED: 'Domain settings deleted successfully',
  },
  ACTIVE_ANNOUNCEMENT: {
    GET_ACTIVE_ANNOUNCEMENT: 'Active Announcement retrieved successfully',
    CREATE_ACTIVE_ANNOUNCEMENT: 'Active Announcement created successfully',
    UPDATE_ACTIVE_ANNOUNCEMENT: 'Active Announcement updated successfully',
    DELETE_ACTIVE_ANNOUNCEMENT: 'Active Announcement deleted successfully',
  },
  MARKETING_DASHBOARD: {
    STATISTICS: 'Successfully retrieved statistics data',
    ITEMS: 'Successfully retrieved top sellings items',
    CHANNELS: 'Successfully retrieved top sellings channels',
    GUESTS: 'Successfully retrieved guests data',
    EMAIL_SMS: 'Successfully retrieved email and sms data',
  },
  NUGGET_CONFIGURATION: {
    UPDATE_FEATURE_FLAGS: 'Nugget Feature Flags Updated Successfully',
  },
  NUGGET_MENU: {
    CREATE_NUGGET_MENU: 'Nugget Menu Created Successfully',
    UPDATE_NUGGET_MENU: 'Nugget Menu Updated Successfully',
    GET_NUGGET_MENU: `Nugget Menu retrieved Successfully`,
    GET_NUGGET_MENU_LIST: 'Nugget Menu retrieved Successfully',
    REMOVE_NUGGET_MENU: `Nugget Menu Removed Successfully`,
  },
  FEATURED_AD: {
    CREATE_FEATURED_AD: 'Featured Ad Created Successfully',
    UPDATED_FEATURED_AD: 'Featured Ad Updated Successfully',
    GET_FEATURED_AD: `Featured Ad Retrieved Successfully`,
    GET_FEATURED_AD_LIST: 'Featured Ad List Retrieved Successfully',
    REMOVE_FEATURED_AD: `Featured Ad Removed Successfully`,
    REARRANGE_FEATURED_AD: `Featured Ad Rearranged Successfully`,
  },
  DOOR_DASH: {
    QUOTE_RETREVIED: 'Quote Retrevied Successfully',
    DELIVERY_CREATED: 'Delivery Created Successfully',
    DELIVERY_RETREVIED: 'Delivery Retrived Successfully',
  },
  NOTIFICATION: {
    NOTIFICATION_RETREVIED: 'Notification Retrevied Successfully',
    NOTIFICATION_TITLE: 'Thank you for your order',
  },
  SQS_NOTIFOCATION: {
    UPDATE_NOTIFICATION: `Notification status successfully updated`,
  },
  WEBSITE_FORMS: {
    FORM_SUBMITTED: 'Form submitted successfully',
    FORMS_FETCHED: 'Forms fetched successfully',
  },
  SETTINGS: {
    RECEIPT_SETTINGS: {
      RECEIPT_SETTINGS_RETREVIED: 'Receipt Settings retrieved successfully',
      RECEIPT_SETTINGS_UPDATED: 'Receipt Settings updated successfully',
    },
    THIRD_PARTY_PRICING: {
      THIRD_PARTY_PRICING_RETREVIED: 'Third Party Pricings retrieved successfully',
      THIRD_PARTY_PRICING_UPDATED: 'Third Party Pricing updated successfully',
    },
    AVG_PREP_TIME: {
      AVG_PREP_TIME_RETREVIED: 'Average Prep Time retrieved successfully',
      AVG_PREP_TIME_UPDATED: 'Average Prep Time updated successfully',
    },
    TIP_SETTINGS: {
      TIP_SETTINGS_RETREVIED: 'Tip Settings retrieved successfully',
      TIP_SETTINGS_UPDATED: 'Tip Settings updated successfully',
    },
  },
  AIO_ASSISTANCE: {
    FETCH_CONVERSATION: 'Conversation fetched successfully',
    FETCH_AI_RESPONSE: 'AI response fetched successfully',
    CLEAR_EMPTY_TABLES: `Successfully clear the empty tables`,
  },
  RECIPE: { SEQUENCE_UPDATED: 'Item sorted successfully' },
  MOM_NOTIFICATION: {
    NOTIFICATION_RETREVIED: 'Fetched mom notifications successfully',
    MARKED_READ: 'Marked Notification as read',
    UNREAD_RETREVIED: 'Fetched unread notifications count successfully',
    MARKED_ALL_READ: 'All notifications are marked as read.',
    MARKED_OPENED: 'Marked as opened.',
  },

  MOM_SETTINGS: {
    MOM_SETTINGS_FETCHED: 'Mom settings fetched successfully',
    MOM_SETTINGS_UPDATED: 'Mom settings updated successfully',
  },
  FIREBASE: {
    FIREBASE_TOKEN_FETCHED: 'Firebase token fetched successfully',
    FIREBASE_MOM_APP_VERSION_UPDATED: 'Firebase mom app version updated successfully',
    FIREBASE_MOM_APP_VERSION_FETCHED: 'Firebase mom app version fetched successfully',
  },
  GIFT_CARD: {
    VALIDATED: 'Gift card validated.',
    BALANCE_RETRIEVED: 'Gift card balance retrieved.',
    TOPUP_COMPLETED: 'Top-up completed successfully',
    TRANSFER_COMPLETED: 'Balance transferred successfully',
    DELETE_TICKET: 'Gift card ticket has deleted successfully',
    RETRIEVED: 'Gift card retrieved successfully.',
    RECEIPT_SENT: 'Gift card receipt sent successfully.',
    CONFIRMATION_SENT: 'Gift card email sent successfully.',
  },
  GIFT_CARD_TICKET: { CREATED: 'Gift card ticket created successfully' },
  ORDER_DELAY: {
    ORDER_DELAY_SUCCESS: 'Order delay updated successfully',
    ORDER_DELAY_FETCHED: 'Order delay fetched successfully',
  },
  DEVICE_STATUS: {
    STATUS_SAVED: 'Heartbeat saved & event published.',
    FETCHED: 'Devices fetched successfully.',
    NO_DEVICES: 'No devices found for this restaurant.',
  },
  THIRD_PARTY_INTEGRATION: {
    GET_STORE_SETTINGS: 'Get store setting successfully',
    SETTINGS_UPDATED: 'Setting updated successfully',
    GET_DOOR_DASH_ORDERS: 'Order retrieved successfully',
  },
};
export const FAILURE_MESSAGE = {
  POLICY: {
    POLICY_NOT_FOUND: 'Policy not found',
    POLICY_INACTIVE: 'Policy is inactive',
  },
  MOM_SETTINGS: {
    MOM_SETTINGS_NOT_FOUND: 'Mom settings not found',
    MOM_SETTINGS_UPDATE_FAILED: 'Failed to update Mom settings',
  },

  INVALID_TIME: 'Time is not valid',
  DELETE_CROPPED_IMAGE: {
    IMAGE_DELETE_FAIL: 'Error while deleting image',
  },
  UPLOAD_IMAGE: {
    IMAGE_UPLOAD_FAIL: 'Error while uploading image',
  },
  BENEFITS: {
    INTEGRATED: {
      NOT_GENERATED: 'Component not generated',
    },
  },
  ACCOUNTING: {
    CHARTS_OF_ACCOUNTS: {
      COLUMNS_MISMATCH: 'CSV headers do not match the expected database columns.',
      ERROR_UPLOADING: 'Error while uploading CSV  ',
      ERROR_FETCHING: 'Error fetching charts of accounts',
      NO_CHART_OF_ACCOUNT_FOUND: 'No chart of account found for given code.',
      ERROR_DOWNLOADING: 'Error downloading charts of account file',
      NO_LOGS_FOUND: 'No logs found for the given chart of account',
      NO_CHARTS_OF_LOGS_FOUND: 'No logs found',
      PARENT_CHART_OF_ACCOUNT: 'Parent chart of account does not exist for : ',
    },
    BILL_PAYMENT: {
      NO_INVOICES_FOUND: 'No invoices found for the provided IDs.',
      INVALID_DATE_FORMAT: 'Invoice date for filtering in MM/DD/YYYY format',
      ALREADY_PAID: 'Invoice already paid for some invoices',
    },

    JOURNAL_ENTRIES: {
      ERROR_FETCHING: 'Error while fetching journal entries',
      UNBALANCED: 'Journal entries are unbalanced',
      ERROR_CREATING: 'Error while creating journal entry',
      ERROR_REVERSING: 'Error while reversing journal entry',
      NOT_FOUND: 'Journal entry not found or already reversed',
    },
    PAYMENT_TYPES: {
      ERROR_FETCHING: 'Error while fetching payment types',
    },
    RECONCILIATION: {
      NOT_FOUND: 'Reconciliation entry not found',
      CANNOT_DELETE_CHILD_ENTRY:
        'Child reconciliation entries cannot be deleted individually. Deleting the parent entry will automatically remove its children.',
      DELETE_FAILED: 'Failed to delete Reconciliation',
      ERROR_FETCHING: 'An error occurred while retrieving AIO transaction entries for reconciliation.',
      ERROR_CREATING: 'An error occurred while creating the reconciliation entry.',
      ERROR_FETCHING_POSSIBLE_MATCHES: 'An error occurred while fetching possible matches.',
      ERROR_FETCHING_BANK_TRANSACTIONS: 'An error occurred while fetching bank transactions.',
      AIO_AND_BANK_DATA_MISSING: 'At least one bank or AIO transaction record must be provided.',
      TRANSACTIONS_DO_NOT_MATCH: 'The transactions do not match: one amount must be the exact negative of the other.',
      BILL_PAYMENTS_ACCEPTED_ONLY: 'Only bill payments made using the payment mode "CC" can be voided.',
      INVOICE_NOT_FOUND: 'The specified invoice was not found.',
      PAYROLL_NOT_FOUND: 'The specified payroll was not found.',
      PAYROLL_METHOD_FETCHING_ISSUE: 'Failed to determine the payroll method.',
      PAYROLL_METHOD_NOT_MANUAL: 'Only Manual Check Payrolls can be marked as Stale Date.',
      DIFFERENCE_IS_NOT_ZERO: 'The difference between the transactions must equal zero.',
      UNEQUAL_MATCH_NOT_ALLOWED: 'No difference to reconcile. Unequal match not allowed.',
      PAYROLL_STALE_DATE_ONLY: 'Only payroll payments can be marked as stale date.',
      BANKS_SHOULD_BE_DIFFERENT:
        'Cash Transfer is allowed only when transaction from two different banks are selected of same amount.',
      BANK_GL_ENTRIES_DIFFERENCE_MUST_BE_ZERO:
        'Add GL Entry action is allowed only when the difference of bank transaction and sum of GL entry lines is zero.',
      ERROR_FETCHING_PAST_RECONCILIATIONS: 'An error occurred while fetching past reconciliations.',
    },
    SALES_CONTROLLER: {
      ERROR_FETCHING_LOGS: 'Error while fetching Sales Controllers Logs',
      SALES_CONTROLLER_UPDATE_FAILED: 'An error occurred while updating the sales controller data',
      FUTURE_DATE_ERROR: 'Sales data for future dates is unavailable. Please select a valid date',
      ERROR_SALES_ORDER_BEFORE_CLOSEOUT: 'Sales order data is unavailable before the restaurant closeout time',
    },
  },
  PAY_SCHEDULE: {
    ON_BOARD_LINK: 'Error while getting onboard link',
    NOT_FOUND: 'Pay schedule not found',
    PAY_SCHEDULE_REQUEST_FAILED: 'Failed to create pay schedule.',
    GET_PAY_SCHEDULES_REQUEST_FAILED: 'Failed to retrieve pay schedules.',
    UPDATE_PAY_SCHEDULE_REQUEST_FAILED: 'Failed to update pay schedule.',
    SECOND_PAY_DAY_NOT_ALLOWED: 'Second payday is only allowed if pay frequency is semi-monthly.',
  },
  KITCHEN_HUB: {
    KITCHEN_HUB_MENU_NOT_FOUND: 'Kitchen Hub Menu not found',
    KITCHEN_HUB_ITEM_NOT_FOUND: 'Kitchen Hub Item not found',
    CREATE_MENU_FAILED: 'Menu creation failed on Kitchen Hub api',
    ALREADY_REJECTED: 'Order already rejected',
    INTEGRATION_ACCOUNT_NOT_FOUND: 'Integration account not found for this restaurant',
  },
  GENERAL_SETTINGS: {
    NOT_FOUND: 'General Settings not found',
  },

  ORDEROUT: {
    ORDER_RECEIVED_FAILED: 'Order receive not successfull',
    ORDER_CREATION_FAILED: 'Order creation not successfull',
    ORDER_CANCELLATION_FAILED: 'Order cancellation not successfull',
    RESTAURANT_NOT_FOUND: 'No restaurants found on orderout',
    MENU_NOT_FOUND: 'Menu not found on orderout',
    ID_NOT_FOUND: 'OrderoutRestaurantId or OrderoutMenuId is not stored',
    ITEMID_NOT_FOUND: 'ItemId not found in orderout order',
    CREATE_MENU_FAILED: 'Menu creation failed on orderout api',
  },
  CHECK_HQ_PAYOUT: {
    INVALID_TYPE: 'Invalid payout type',
    CHECK_HQ_AUTH: 'Check hq error while creating employee.',
    SIGNATORY_NOT_FOUND: 'Company signatory not found',
  },
  PAY_ROLL: {
    PAYROLL_NOT_SETUP: 'The Payroll has not been setup',
    APPROVAL_DEADLINE_PASSED: 'Approval deadline passed, create an offcycle payroll.',
    PAY_PERIOD_NOT_ENDED: 'Your payroll cannot be processed as the pay period has not ended yet.',
    EXISTING_PAYROLL: 'Payroll already exists for this pay period.',
    NO_PAYROLL_DATA: 'No earning data found for payroll',
  },
  PLAID: {
    NO_BANKS_FOUND: 'No banks found for the given restaurant ID.',
    NO_BANK_FOUND: 'No bank found for the given restaurant ID and bank name.',
    BANK_WITH_SAME_PURPOSE_FOUND: 'There is already bank attached for this purpose',
    NO_ATTACHED_BANK: 'There is no bank attached for any purpose',
    NO_PURPOSE_SELECTED: 'No purpose selected',
    ERROR_CREATING_LINK_TOKEN: 'Error creating link token.',
    ERROR_EXCHANGING_PUBLIC_TOKEN: 'Error exchanging public token.',
    ERROR_SAVING_TOKEN: 'Error saving token.',
    ERROR_FETCHING_BANK_DETAILS: 'Error fetching bank details.',
    ERROR_DELETING_BANK: 'Error deleting bank.',
    ERROR_FETCHING_PUBLIC_TOKEN: 'Error fetching public token.',
  },
  VAULT_CATEGORY: {
    VAULT_CATEGORY_NOT_FOUND: 'No such vault category was found',
    INVALID_UPDATE_REQUEST: 'Invalid update request',
    NON_DELETE_ABLE_VAULT_CATEGORY: 'Cannot delete a non-custom vault category',
    NON_UPDATE_ABLE_VAULT_CATEGORY: 'Cannot update a non-custom vault category',
    MAX_LIMIT_REACHED: 'Max Custom Categories limit reached',
    VAULT_CATEGORY_ALREADY_EXISTS: 'Vault already exists',
  },
  VAULT_CATEGORY_ITEM: {
    VAULT_CATEGORY_PARENT_NOT_FOUND: 'No such parent folder was found',
    NOT_FOUND: 'No such vault category was found',
    INVALID_UPDATE_REQUEST: 'Invalid update request',
    NO_ACCESS: 'Access Denied',
  },
  FINANCIAL_CONFIG: {
    NO_ACTIVE_FINANCIAL_CONFIG_FOUND: 'No active financial configuration found',
  },
  LOST_AND_FOUND: {
    ITEM_NOT_FOUND: 'The lost/found item could not be found.',
    INVALID_CUSTOMER_DETAILS: 'Please input customer details',
    FILE: 'Invalid file size/type',
    TABLE_NOT_FOUND: 'Invalid table number',
  },
  TABLE: {
    ASSIGN_TABLE: 'Table assigned SucessFully',
    TABLE_NOT_FOUND: 'Table not found',
    TABLE_NOT_AVAILABLE: 'This table is not available right now',
    TABLE_ALREADY_ASSIGNED: 'The current table is already occupied. You can view the menu here.',
  },
  FLOOR: {
    FLOOR_NOT_FOUND: 'Floor Not Found',
    FLOOR_ALREADY_EXISTS: 'Floor with this name already exists.',
  },
  QR: {
    ERROR_CREATING: 'Error creating QR',
  },
  QR_ORDER: {
    INITIATE_ORDER: 'Failed to initiate order',
    TABLE_NOT_FOUND: 'Table not found',
    PRE_AUTH: 'Pre Auth Failed',
    INCREMENT_AUTH: 'Increment Auth Failed',
    CAPTURE_PAYMENT: 'Capture Payment Failed',
    CART_NOT_FOUND: 'Cart not found',
    QR_NOT_FOUND: 'QR not found',
  },
  TASKS: {
    TASK_NOT_FOUND: 'Task not found',
    USER_RESTAURANT_NOT_FOUND: 'User restaurant not found',
    PERMISSION_DENIED: 'You do not have permission to perform this action',
    TASK_CREATION_FAILED: 'Failed to create task',
    TASK_UPDATE_FAILED: 'Failed to update task',
    TASK_COMPLETION_FAILED: 'Failed to complete task',
    TASK_COMPLETION_WITH_NUMERICAL_VALUE: 'Numerical value is mandatory',
    TASK_COMPLETION_WITHOUT_PHOTO: 'Photo is mandatory',
    TASK_HISTORY_FETCH_FAILED: 'Failed to fetch task history',
    IMAGE_UPLOAD_FAIL: 'Error while uploading image',
    TASK_ALREADY_COMPLETED: 'Task is already marked as completed',
    TASK_START_TASK_BEFORE_COMPLETE: 'Task should be in progress before compeletion',
  },
  WEBSITE: {
    TEMPLATE_NOT_GENERATED: 'Either template files are missing or fs.writeFileSync() failed',
    PATH_NOT_FOUND: 'Path not found',
    ERROR_FILE_UPLOADING: 'Error in file uploading',
    TEMPLATE_NOT_DOWNLOADED: 'Templates Not downloaded',
  },
  PAYMENT: {
    PAYMENT_NOT_FOUND: 'Payment instance not found',
    PAYMENT_INTENT_CREATION: 'Payment Intent Creation Failed',
    PAYMENT_DEVICE_INITIALIZATION_FAILED:
      'Failed to initialize the payment on payment device. There may be a network issue or device is disconnected.',
    PUBLISHABLE_KEY_NOT_FOUND: 'Publishable Key Not Found',
    PAYMENT_SUCCESS_BUT_FAILED_TRANSACTION: 'Payment Successful but failed to create transaction',
    BUSINESS_ID_NOT_FOUND: 'Business Id Not Found',
    CANNOT_CANCEL_INTENT_CHARGE_ALREADY_SUCCEEDED:
      'Cannot cancel the Payment Intent because the charge has already succeeded.',
    PAYMENT_INTENT_CAPTURED: 'Unable to Capture the payment intent',
    PAYMENT_SUCCESS_BUT_FAILED_ADVISORY_LOCK: 'Payment Successful but failed due to advisory lock',
    PAYMENT_TIP_NOT_ADDED: 'Unable to add tip',
    ALREADY_PAID: 'Unable to cancel as it is already paid. Please proceed to refund.',
    PAYMENT_ALREADY_PROCESSING: 'Cannot Cancel the payment because it is already in processing.',
    IN_PROCESS: 'The payment against this order is already being processed.',
    MISSING_DATA: 'Unable to retrieve payment data at the moment.',
  },

  SALES_TAX: {
    SALES_TAX_NOT_CREATED: 'SalesTax not created',
    SALES_TAX_NOT_UPDATED: 'SalesTax not updated',
    SALES_TAX_NOT_FOUND: `SalesTax not retrieved`,
    GET_SALES_TAX_NOT_LIST: 'SalesTax list not retrieved',
    SALES_TAX_NOT_REMOVED: `SalesTax not removed`,
  },
  TENDER: {
    TENDER_NOT_CREATED: 'Tender not created',
    TENDER_NOT_UPDATED: 'Tender not updated',
    TENDER_NOT_FOUND: `Tender not retrieved`,
    GET_TENDER_NOT_LIST: 'Tender list not retrieved',
    TENDER_NOT_REMOVED: `Tender not removed`,
    TENDER_LOG_NOT_FOUND: `Tender Log not retrieved`,
  },
  REPORTS: {
    INVALID_PERIOD: 'Period must be one of the following values: daily, weekly, monthly, yearly',
  },

  OPERATIONS: {
    OPERATIONS_USER_NOT_CREATED: 'Operation User not created',
    OPERATIONS_USER_NOT_UPDATED: 'Operation User not updated',
    OPERATIONS_USER_NOT_FOUND: `Operation User not retrieved`,
    GET_OPERATIONS_USER_NOT_LIST: 'Operation User list not retrieved',
    OPERATIONS_USER_NOT_REMOVED: `Operation User not removed`,
  },

  AIO_BUDDY: {
    AIO_BUDDY_USER_NOT_CREATED: 'Aio Buddy User not created',
    AIO_BUDDY_USER_NOT_UPDATED: 'Aio Buddy User not updated',
    AIO_BUDDY_USER_NOT_FOUND: `Aio Buddy User not retrieved`,
    GET_AIO_BUDDY_USER_NOT_LIST: 'Aio Buddy User list not retrieved',
    AIO_BUDDY_USER_NOT_REMOVED: `Aio Buddy User not removed`,
  },

  MENU: {
    MENU_NOT_FOUND: 'Menu not found',
    CATEGORY_NOT_FOUND: 'Category not found',
    TAG_NOT_FOUND: 'Tag not found',
    ALLERGEN_NOT_FOUND: 'Tag not found',
    MODIFIER_GROUP_NOT_FOUND: 'ModiferGroup not found',
    MODIFIER_NOT_FOUND: 'Modifer not found',
    ITEM_NOT_FOUND: 'Item not found',
    TOP_ITEMS_NOT_FOUND: 'Top Items not found',
    ADDON_NOT_FOUND: 'AddOn Not Found',
    MENU_NOT_REMOVED: 'Menu not removed',
    MENU_NOT_CREATED: 'Menu not created',
    REARRANGE_ERROR: 'Menu not rearranged',
    INVALID_MENU_VERSION: 'Invalid menu version',
  },
  STORAGE_AREA: {
    STORAGE_AREA_NOT_FOUND: 'Storage Area Not Found',
  },
  ITEM: {
    ITEMS_NOT_FOUND: 'Items not found',
    ITEM_ALREADY_IN_SAME_STATUS: 'Item is already in the same status',
  },
  TAGALLERGENS: {
    TAG_NOT_REMOVED: 'Tag not removed',
    TAGS_ALLERGENS_NOT_FETCH: `Failed to fetch tags and allergens`,
  },
  CATEGORY: {
    CATEGORY_NOT_FOUND: 'Category not found',
    CATEGORIES_NOT_FOUND: 'Categories not found',
    CATEGORY_NOT_REMOVED: 'Category not removed',
    CATEGORY_NOT_CREATED: 'Category not created',
    CATEGORY_NOT_UPDATED: 'Category not updated',
    REARRANGE_ERROR: 'Categories not rearranged',
  },
  MODIFIER_OPTIONS: {
    MODIFIER_OPTION_NOT_CREATED: 'ModifierOption not created',
    MODIFIER_OPTION_NOT_UPDATED: 'ModifierOption not updated',
    MODIFIER_OPTION_NOT_FOUND: `ModifierOption not retrieved`,
    GET_MODIFIER_OPTION_NOT_LIST: 'ModifierOption list not retrieved',
    MODIFIER_OPTION_NOT_REMOVED: `ModifierOption not removed`,
    MODIFIER_OPTION_ALREADY_IN_SAME_STATUS: 'ModifierOption is already in the same status',
  },
  MODIFIER: {
    MODIFIER_NOT_FOUND: 'Modifier not found',
    MODIFIERS_NOT_FOUND: 'Modifiers not found',
    MODIFIER_NOT_REMOVED: 'Modifier not removed',
    MODIFIER_NOT_CREATED: 'Modifier not created',
    MODIFIER_NOT_UPDATED: 'Modifier not updated',
    REARRANGE_ERROR: 'Modifiers not rearranged',
  },
  RESTAURANT_REVIEW: {
    NOT_FOUND: 'Restaurant Review not found',
    INVALID_STATUS: 'Invalid Status',
    ALREADY_RESPONDED_OR_NOT_FOUND: 'Review already responded or not found',
    REVIEW_ALREADY_POSTED: 'Review against this ticket is already posted',
  },
  CUSTOMER: {
    CUSTOMER_NOT_FOUND: 'Customers not found',
    UNABLE_TO_LINK_CUSTOMER_RESTAURANT: 'Unable to link customer with restaurant',
    LOGIN_DISABLED: 'This customer does not have permission to login',
    CUSTOMER_ALREADY_EXISTS: 'Customer already exists',
    CUSTOMER_CREATION_FAILED: 'Customer creation failed',
  },
  GUEST: {
    GUEST_NOT_FOUND: 'Guest not found',
    SEGMENT_NOT_FOUND: 'Guest segments not found',
    CATEGORY_LIMIT_EXCEEDED: 'You can only create up to 15 categories',
  },
  SPOTLIGHT: {
    SPOTLIGHT_NOT_FOUND: 'Spotlight not found',
  },
  DEAL: {
    DEAL_NOT_FOUND: 'Deal not found',
    INVALID_START_TIME: 'Deal start time is not valid',
    DEAL_NOT_ACTIVE: 'Deal not active',
    DEAL_NOT_OPERATIONAL_YET: 'Deal not operational yet',
    DEAL_NOT_PART_OF_CAMPAIGN: 'Deal not part of campaign',
    CAMPAIGN_NOT_PUBLISHED: 'Campaign not published',
    DEAL_ARCHIVED: 'Deal is archived',
    NO_BUY_ITEMS_SPECIFIED: 'No eligible items added',
    DEAL_NOT_VALID_ON_CURRENT_DAY: 'Deal not valid on current day',
    INVALID_BUYTYPE_SPECIFIED: 'Invalid buy type specified',
    INVALID_GETTYPE_SPECIFIED: 'Invalid get type specified',

    DEAL_ELIGIBLE_ITEMS_NOT_FOUND: 'Deal eligible items not found',
    ACHIEVE_MINIMUM_QUANTITY: (quantity: number) =>
      `Add minimum quantity of ${quantity} items to qualify for this deal`,
    ACHIEVE_MINIMUM_PRICE: (price: number) => `Achieve ticket amount of $${price} to qualify for this deal`,
    ACHIEVE_GET_THAT_QUANTITY: (quantity: number) =>
      `Add quantity of ${quantity} items to fulfill the get that portion of this deal`,
    TICKET_ITEM_QUANTITY_MISMATCH: (itemName: string, current_quantity: number, desired_quantity: number) =>
      `The item with ${itemName} does not meet the required quantity. Required: ${desired_quantity}, Found: ${current_quantity}`,
    CANNOT_BE_APPLIED_WITH_OTHER_DEALS_AND_DISCOUNTS:
      'This deal cannot be applied in combination with other deals and discounts',
  },
  JOURNEY: {
    JOURNEY_NOT_FOUND: 'Journey not found',
    JOURNEY_DUPLICATE_CHANNELS: 'Can not enter duplicate channels',
    JOURNEY_NO_CONTENT: 'Content cannot be empty',
  },
  INTEGRATIONS: {
    TRIPADVISOR: {
      CONNECTED: 'Tripadvisor account already connected.',
      NOT_CONNECTED: 'Tripadvisor account is not connected.',
    },
    GOOGLE: {
      CONNECTED: 'Google account already connected.',
      SCOPES: 'Kindly specify all permissions.',
      NOT_CONNECTED: 'Google account is not connected.',
      REVOKE_TOKEN: 'Google token expired or revoked.',
      FAILED_AUTH: 'Unable to connect Google account.',
      NO_LOCATIONS: 'No locations found connected with this Google account',
      REVIEWS_ERROR: 'Not able to process reviews',
      REVIEW_REPLY_ERROR: 'Not able to process review reply',
      REVIEW_REPLY_DELETE_ERROR: 'Unable to delete review reply',
      REVIEW_DECODING_ERROR: 'Something went wrong in decoding message',
      REVIEW_NOTIFICATION_ERROR: 'Something went wrong in updating google notification',
      DELETE_NOTIFICATION_ERROR: 'Something went wrong in updating google notification',
    },
    GOOGLE_SEARCH_CONSOLE: {
      SITE_VERIFICATION_TOKEN: 'Failed to generate Google Search Console site verification token',
      VERIFY_SITE: 'Failed to verify site in Google Search Console',
      ADD_SITE: 'Failed to add site to Google Search Console',
      SUBMIT_SITEMAP: 'Failed to submit sitemap to Google Search Console',
      GET_SITEMAPS: 'Failed to fetch sitemaps from Google Search Console',
      DELETE_NOTIFICATION_ERROR: 'Something went wrong in updating google notification',
    },
    META: {
      NOT_CONNECTED: 'Meta account is not connected.',
      FACEBOOK_CONNECTED: 'Facebook account already connected.',
      FACEBOOK_NOT_CONNECTED: 'Facebook account is not connected.',
      INSTAGRAM_CONNECTED: 'Instagram account already connected.',
      INSTAGRAM_NOT_CONNECTED: 'Instagram account is not connected.',
      AUTHORIZE: 'Authorization code is invalid',
      REVOKE_TOKEN: 'Failed to disconnect.',
      [MetaPhotoErrorCode.ACTION_DEEMED_ABUSIVE]:
        'The action attempted has been deemed abusive or is otherwise disallowed.',
      [MetaPhotoErrorCode.PERMISSIONS_ERROR]:
        'Permissions error. Ensure the user or app has the necessary permissions.',
      [MetaPhotoErrorCode.INVALID_OAUTH_TOKEN]: 'Ensure the access is valid and not expired.',
      [MetaPhotoErrorCode.INVALID_PARAMETER]: 'Invalid parameter. Check the input parameters and try again.',
      [MetaPhotoErrorCode.MISSING_OR_INVALID_IMAGE_FILE]:
        'Missing or invalid image file. Ensure the file is uploaded correctly and meets the required format.',
      [MetaPhotoErrorCode.TOO_MANY_CALLS_TO_PAGE_ACCOUNT]:
        'Too many calls to this Page account. Wait a while and try again.',
      [MetaPhotoErrorCode.DESKTOP_APP_FUNCTION_RESTRICTED]:
        'Desktop applications cannot call this function for other users.',
      [MetaPhotoErrorCode.INVALID_VAULT_IMAGE_ID]: 'Invalid vault image ID. Verify the image ID and try again.',
    },
    TIKTOK: {
      CONNECTED: 'TikTok account already connected.',
      SCOPES: 'Kindly specify all permissions.',
      NOT_CONNECTED: 'TikTok account is not connected.',
      REVOKE_TOKEN: 'TikTok token expired or revoked.',
      FAILED_AUTH: 'Unable to connect TikTok account.',
      CREATOR_NOT_FOUND: 'TikTok creator not found.',
      [TikTokErrorCode.INVALID_PARAM]: 'Invalid parameters.',
      [TikTokErrorCode.APP_VERSION_CHECK_FAILED]: 'Outdated TikTok app version must be at least 31.8.',
      [TikTokErrorCode.SPAM_RISK_TOO_MANY_POSTS]: 'Daily post cap is reached for your account.',
      [TikTokErrorCode.SPAM_RISK_USER_BANNED_FROM_POSTING]: 'You are banned by TikTok from making new posts.',
      [TikTokErrorCode.SPAM_RISK_TOO_MANY_PENDING_SHARE]:
        'Daily upload cap reached. No more than 5 pending shares are allowed within 24 hours.',
      [TikTokErrorCode.REACHED_ACTIVE_USER_CAP]: 'Daily quota for active publishing users is reached.',
      [TikTokErrorCode.UNAUDITED_CLIENT_POST_TO_PRIVATE_ONLY]:
        'Unaudited clients can only post to private accounts. Publish attempts to public accounts are blocked.',
      [TikTokErrorCode.URL_OWNERSHIP_UNVERIFIED]:
        'URL ownership is unverified. Verify ownership of the URL prefix or domain.',
      [TikTokErrorCode.PRIVACY_LEVEL_OPTION_MISMATCH]: 'Privacy level is unspecified.',
      [TikTokErrorCode.ACCESS_TOKEN_INVALID]: 'Your access has expired.',
      [TikTokErrorCode.SCOPE_NOT_AUTHORIZED]: 'Your access does not have the necessary scope for this operation.',
      [TikTokErrorCode.RATE_LIMIT_EXCEEDED]: 'Your request is blocked due to exceeding rate limit.',
      [TikTokErrorCode.INTERNAL_ERROR]: 'Internal server or network error. Please try again later.',
      [TikTokErrorCode.TIKTOK_SERVER_ERROR]: 'TikTok server or network error. Try again later.',
      [TikTokFailReasonCode.FILE_FORMAT_CHECK_FAILED]:
        'Unsupported media format. See Video Restrictions and Photo Restrictions.',
      [TikTokFailReasonCode.DURATION_CHECK_FAILED]:
        "Video does not meet TikTok's duration restrictions. See Video Restrictions.",
      [TikTokFailReasonCode.FRAME_RATE_CHECK_FAILED]: 'Unsupported frame rate. See Video Restrictions.',
      [TikTokFailReasonCode.PICTURE_SIZE_CHECK_FAILED]:
        'Unsupported picture size. See Video Restrictions and Photo Restrictions.',
      [TikTokFailReasonCode.INTERNAL]:
        'Some parts of the TikTok server may currently be unavailable. Retry after a while.',
      [TikTokFailReasonCode.VIDEO_PULL_FAILED]:
        'The TikTok server encountered a connection error while downloading the specified video resource, or the download is terminated since it cannot be completed within the one-hour timeout. Ensure the supplied URL is publicly accessible or bandwidth-limited.',
      [TikTokFailReasonCode.PHOTO_PULL_FAILED]:
        'The TikTok server encountered a connection error while downloading the specified photo resource, or the download is terminated since it cannot be completed within the one-hour timeout. Ensure the supplied URL is publicly accessible or bandwidth-limited.',
      [TikTokFailReasonCode.PUBLISH_CANCELLED]: 'The upload/download process was cancelled by the developer.',
      [TikTokFailReasonCode.AUTH_REMOVED]:
        "The TikTok creator has removed the developer's access during the download/upload process. Retry should not be done.",
      [TikTokFailReasonCode.SPAM_RISK_TEXT]:
        "TikTok's Trust and Safety team flagged the description text as risky or spammy, so the publishing attempt is terminated. Retry should not be done.",
      [TikTokFailReasonCode.SPAM_RISK]:
        "TikTok's Trust and Safety team determined the publishing request is risky, so the attempt is terminated. Retry should not be done.",
    },
    YELP: {
      CONNECTED: 'Yelp account already connected.',
      SCOPES: 'Kindly specify all permissions.',
      NOT_CONNECTED: 'Yelp account is not connected.',
      BUSINESS_NOT_CONNECTED: 'Yelp business is not connected.',
      REVOKE_TOKEN: 'Yelp token expired or revoked.',
      FAILED_AUTH: 'Unable to connect Yelp account.',
      PROFILE_NOT_FOUND: 'Yelp profile not found.',
      REVIEWS_ERROR: 'Not able to send review',
    },
  },
  REVIEW_MANAGEMENT: {
    TOPICS: {
      FAILED_GENERATION: 'Failed to generate topics',
    },
    SUMMARIES: {
      FAILED_GENERATION: 'Failed to generate summaries',
    },
    ASPECT: {
      FAILED_GENERATION: 'Failed to generate aspects',
    },
    REVIEW: {
      URL_EXISTS: 'Scrapper source alreay exists.',
      URL_NOT_FOUND: 'Scrapper source does not exists.',
      NOT_FOUND: 'Review not found.',
      RESPONSE_EXISTS: 'Review response already posted.',
      SOURCE_NOT_FOUND: 'Can not post reply to this source.',
      Google_DETAILS_NOT_FOUND: 'Review google details not found.',
      REVIEW_USER_RESTAURANT_ID: 'Review user restaurant id not found.',
      REVIEW_REPLY_NOT_FOUND: 'Review response not found.',
      SCRAPPER_ACCOUNT_NOT_FOUND: 'Account not found',
    },
  },
  CAMPAIGN: {
    CAMPAIGN_NOT_FOUND: 'Campaign not found',
    CAMPAIGN_EXPIRED: 'Campaign is expired',
    REPOSITORY_NOT_FOUND: 'Repository not found',
    HOLIDAY_NOT_FOUND: 'Holiday not found',
  },
  EMPLOYEE: {
    EMPLOYEES_NOT_FOUND: 'Employee list not found',
    NOT_FOUND: 'Employee not found',
    EMAIL_NOT_VERIFIED: 'Employee email not verified',
    REVIEW_NOT_ADDED: 'Review could not be added',
    NOT_CREATED: 'Unable to create employee',
    NOT_UPDATED: 'Unable to update employee',
    EMAIL_ALREADY_IN_USE: 'Email is already in use',
    CONTACT_NO_ALREADY_IN_USE: 'Contact number is already in use',
  },
  EMPLOYEE_AVAILABILITY: {
    TIMESLOT_OVERLAPPING: 'Invalid time slots: Overlapping times detected',
    INVALID_TIMESLOT: 'Invalid time slots: End time must be after start time',
  },
  EMPLOYEE_SHIFT: {
    NOT_FOUND: 'Employee shift not found',
    SWAP_REQUEST_NOT_FOUND: 'Swap request not found',
    NOT_RELEASED_SWAP: 'Shift is not released nor swap',
    ALREADY_RELEASED: 'Shift is already in the pool',
    BREAK_VIOLATION: 'Break violations detected',
    SWAP_APPROVED: 'Swap request is already approved',
    SWAP_DECLINED: 'Swap request is already declined',
    START_TIME_EXCEEDED: 'Cannot release close to shift start time',
    ROLE_CONFLICT: 'Conflicting roles, unable to process',
    NOT_PUBLISHED: 'Shift is not published',
  },
  SHIFT_POOL: {
    NOT_FOUND: 'Shift pool not found',
    BID_NOT_FOUND: 'Shift bid not found',
    SWAP_BID_NOT_ALLOWED: 'Bid is not allowed on swap requests',
    BID_ROLE_CONFLICT: 'Conflicting roles, unable to bid',
    BIDDED_FOUND: 'Bid already submitted on this shift',
  },
  SSE: {
    EVENT_NOT_SENT: 'Event not sent to Device',
  },
  TICKET: {
    TICKET_NOT_FOUND: 'Ticket not found',
    TICKET_NOT_UPDATED: 'Ticket not updated',
    CREATED: 'Ticket not created',
    TICKET_ALREADY_PAID: 'Ticket is already paid',
    TICKET_REMAINING_AMOUNT: 'Paid amount is greater than remaining amount',
    TICKET_NO_OF_GUESTS_ALLOWED_LIMIT: 'Number of guests can not be greater than 99',
    TICKET_VOIDED: 'Ticket is voided',
    CREATE_TICKET_NOTE_ALLOWED_LIMIT: 'Note cannot be longer than 50 characters',
    LOYALTY_ALREADY_APPLIED: 'Loyalty already applied',
    LOYALTY_ITEM_NOT_FOUND: 'No such loyalty item found',
    NO_OF_GUESTS_REQUIRED: 'Number of guests is required',
    VOIDED_TICKET: 'Cannot Update Voided Ticket',
    TICKET_ALREADY_FIRED: 'Ticket already fired',
    TICKET_CANNOT_CANCEL: 'You cannot cancel this ticket — only scheduled tickets can be cancelled',
  },

  TICKET_ITEM: {
    TICKET_ITEM_NOT_FOUND: 'Ticket Item not found',
    CREATED: 'Ticket Item not created',
    DELETE_TICKET_ITEM: 'Unable to delete ticket items because the status of some items is marked as SEND.',
    NOT_LINKED_WITH_KDS_ORDER: 'Ticket item not linked with kds order',
  },

  CUSTOM_ITEM: {
    CUSTOM_ITEM_NOT_FOUND: 'Custom Item not found',
    NOT_LINKED_WITH_KDS_ORDER: 'Ticket item not linked with kds order',
  },
  AUTHENTICATION: {
    NOT_AUTHORIZED: 'user not authorized', // this message only use for authorization in custom don't use this message becasue of this message we handling things on UI
    NOT_AUTHORIZED_RESTAURANT: 'user not authorized to this restaurant , please contact admin',
    GET_USER: 'user not found',
    SIGN_UP: 'user not created',
    USER_EXISTS: 'user already exists',
    USER_LOGGED_IN: 'user already logged in',
    USER_NOT_LOGGED_IN: 'user not logged in',
    DIFFERENT_DEVICE_LOG_IN_FOUND: 'user is logged in a different device',
    USER_EXISTS_BUSINESS: 'user with this username already exists in this business',
    USER_EXISTS_AIO: 'user with this username already exists in AIO platform',
    SEND_OTP: 'OTP failed to send',
    USER_DOESNT_EXIST: 'user does not exist',
    INCORRECT_PIN_ENTERED: 'Incorrect pin entered',
    USER_ALREADY_ACTIVATED: 'user already activated',
    USER_UNKNOWN: 'user status unknown',
    USER_NOT_ACTIVATED: 'user not activated',
    USER_DEACTIVATED: 'user deactivated',
    NOT_IMPLEMENTED: 'not implemented',
    VERIFY_OTP: 'OTP verification failed',
    UPDATE_PASSWORD: 'password update failed',
    LOGIN_USER: 'login failed',
    INCORRECT_OTP: 'incorrect OTP entered',
    REFRESH_TOKEN: 'tokens regeneration failed',
    SET_USER_ATTRIBUTES: 'user attributes set failed',
    INVALID_ACCESS_TOKEN: 'Invalid access token provided',
    INVALID_REFRESH_TOKEN: 'Invalid refresh token provided',
    INVALID_ID_TOKEN: 'Invalid id token provided',
    INVALID_ACCESS_HEADERS: 'Invalid access headers provided',
    TOKEN_MISSING: 'Please provide the necessary token for access.',
    HEADERS_MISSING: 'Invalid access headers provided',
    ID_TOKEN_MISSING: 'Please provide the necessary id token for access.',
    REFRESH_TOKEN_MISSING: 'Please provide the necessary refresh token for access.',
    USERNAME: 'username not found',
    SECRET: 'secret not found',
    ATTRIBUTE_ALREADY_VERIFIED: 'email/phone_number alread verified',
    ATTRIBUTE: 'email/phone_number not found',
    RESEND_EMAIL_VERIFICATION_LINK: 'failed to resend email verification link',
    EMAIL_ATTR_VERIFICATION: 'email verification failed',
    TOKEN_GENERATED: 'token generation failed',
    CHANGE_PASSWORD: 'failed to change password',
    DEACTIVATE_ACCOUNT: 'failed to deactivate account',
    USER_ALREADY_DEACTIVATED: 'user already deactivated',
    LOGIN_BAN: 'user blocked from login',
    VERIFY_MFA_CODE: 'MFA code verification failed',
    VERIFY_2FA_CODE: '2FA code verification failed',
    ATTRIBUTE_VERIFIED: 'email/phone_number verification failed',
    TOGGLE_MFA: 'MFA toggle failed',
    PASSWORD_ATTEMPTS_EXCEEDED: 'Password attempts exceeded',
    INCORRECT_USERNAME_PASSWORD: 'Incorrect username or password.',
    PASSWORD_LOWERCASE_FAILURE: 'Password must have lowercase characters',
    PASSWORD_UPPERCASE_FAILURE: 'Password must have uppercase characters',
    LOGIN_WITH_POS_PIN: 'login with pos pin failed',
    LOGOUT: 'Log out failed',
    APPROVER_POS_PIN: 'approver pos pin failed',
    FORGOT_PASSWORD: 'forgot password failed',
    CONFIRM_FORGOT_PASSWORD: 'confirm forgot password failed',
    BUSINESS_NOT_FOUND: 'Business not found',
    CLOCKIN_FROM_POS_NEEDED: 'Clockin from main pos needed',
    USER_BLOCKED_FOR_15_MINS: 'User blocked for 15 minutes',
    DUPLICATE_ENTRY: 'Duplicate entry',
    INVALID_PASSWORD: 'Incorrect Password',
    CART_NOT_FOUND: 'Cart Not Found',
    USER_TYPE_ERROR: 'Registration is failed user type is not correct',
    INVALID_UESERNAME: 'username must be a valid email address or phone number',
    INVALID_PASSWORD_LENGTH: 'password must be longer than or equal to 8 characters',
    DEVICE_NOT_FOUND: 'Device not found.',
    DEVICE_NOT_MAPPED: 'This device is not Mapped to this restaurant.',
    SUPER_ADMIN_PASSWORD_ERROR:
      'You do not have access to create a super admin. The Pass code you provided is incorrect.',
    ENABLE_EMAIL_2FA: '2FA enable failed',
    DEVICE_REVOKED: 'This device has been revoked.',
    INVALID_ORIGIN: 'origin is not allowed to access the requested route.',
    SOCIAL_LOGIN_FAILED: 'Social login failed',
    ENABLE_2FA_USER: '2FA enable for superadmin and operation failed',
    FORGOT_PASSWORD_USER: 'failed to send forgot password email',
    FORGOT_PASSWORD_OTP_VERIFICATION: 'Forgot password otp verification failed',
    PROVIDED_TOKEN_EXPIRED: 'Provided token is expired',
    USER_AUTH_FAILED: 'User authentication failed',
    TENANT_RESTAURANT_USER_IDS_REQUIRED: 'tenant, restaurant and user id is required',
    ONlY_GET_REQ_ALLOWED: 'This API supports GET requests only',
    THIRD_PARTY_PUBLIC_KEY_MISSING: 'AI_TEAM_ACCESS_PUBLIC_KEY missing',
    PASSWORD_RESET: 'Your session has expired due to a password reset request. Please log in again.',
    PASSWORD_RESET_INITIATED: 'PASSWORD_RESET',
  },
  USER: {
    IMAGE_FILE_TYPE: 'File should have .png, .jpeg or .heic extension',
    HTML_FILE_TYPE: 'File should have .html extension',
    DOC_FILE_TYPE: 'File should have .pdf, .docx extension',
    FILE_SIZE: 'File size too big',
    UPLOAD: 'File upload failed',
    DELETE: 'File delete failed',
    FILE_DOESNT_EXIST: 'File does not exist',
    INTERNAL_USER_DATA: 'Error while getting internal user data',
    EMPLOYEE_DATA: 'Error while getting employee data',
    AccessDeniedAPI: 'Access denied to API',
  },
  ONBOARDING_DOCUMENTS: {
    ONBOARDING_DOCUMENTS_NOT_FOUND: 'Onboarding Documents not found',
  },
  EMPLOYEE_DOCUMENTS: {
    EMPLOYEE_DOCUMENTS_NOT_FOUND: 'Employee Documents not found',
    EMPLOYEE_DOCUMENTS_EXISTS: 'Employee Documents already exists',
    EMPLOYEE_DOCUMENTS_FAILED_TO_CREATE: 'Employee Documents failed to create',
    MAX_LIMIT: 'Cannot upload documents more than 10',
  },
  CART_ITEM: {
    OUT_OF_STOCK_POST_ITEM: 'Failed to add cart item because this is currently out of stock',
    OUT_OF_STOCK_UPDATE_ITEM: 'Failed to update cart item because this is currently out of stock',
    CART_ITEM_NOT_FOUND: 'Cart Item not found',
  },
  CART: {
    CHECKOUT_FAILED: 'Cart check out failed',
    EMPTY_CART_FOUND: 'Operation could not be performed because the cart is empty',
    OUT_OF_STOCK_CHECKOUT_FAILURE: 'Some items in your cart are out of stock. Please remove them to continue.',
    UNAVAILABLE_ITEMS_CHECKOUT_FAILURE: 'Some of the items you ordered are no longer available.',
    MODIFIER_OUT_OF_STOCK: 'Some items in your cart have out of stock modifiers. Please remove them to continue',
    NO_ACTIVE_CART_FOUND: 'No active cart found',
    NO_CUSTOMER_CART_FOUND: 'No active cart found of this customer',
    ADD_ON_NOT_FOUND: 'Add on not found',
    MODIFIER_NOT_FOUND: 'Modifier not found',
    MODIFIER_OPTIONS_NOT_FOUND: 'Modifier Option not found',
    NO_CART_COMPLETED: 'Cart payment not completed',
    CART_NOT_FOUND: 'Cart not found.',
    CART_ALREADY_PAID: 'Cart is already paid',
  },
  FEED_BACK: {
    ALREADY_LIKED: 'Item has already been liked.',
  },
  DEVICE_SETTINGS: {
    NOT_FOUND: 'Device Settings not found',
    INVALID_PAYMENT_SETTINGS: 'Cannot disable all methods',
    INVALID_AVG_PREP_TIME: 'Average prep time must be between 1 minute and 72 hours',
  },
  CASH_DRAWER: {
    CREATE_CASH_DRAWER: 'Cash Drawer creation failed',
    CASH_DRAWER_NOT_FOUND: 'Cash Drawer not found',
    CASH_DRAWER_CLOSED: 'Cash Drawer is closed',
    INSUFFICIENT_AMOUNT: 'Insufficient amount',
    MISMATCHING_POS_FOUND: 'This cash drawer is not connected to this pos',
    GET_CASH_DRAWER_FAILED: 'Cash drawer fetched failed',
    DELETE_CASH_DRAWER_FAILED: 'Cash drawer deleted failed',
    UPDATE_CASH_DRAWER_FAILED: 'Cash drawer updated failed',
    GET_CASH_DRAWER_BY_ID_FAILED: 'Cash drawer fetched by id failed',
    CREATE_CASH_DRAWER_FAILED: 'Cash Drawer creation failed',
    EMPLOYEE_NOT_ASSIGNED: 'This employee is already unassigned to this cash drawer',
    EMPLOYEE_ALREADY_ASSIGNED: 'Employee is already assigned',
    GET_ASSIGNED_EMPLOYEE_FAILED: 'Assigned Employee could not be fetched',
    EMPLOYEE_UNASSIGNMENT_FAILED: 'Employee unassignment failed',
    CASH_DRAWER_ALREADY_OPEN: 'Cash Drawer is already open',
    CASH_DRAWER_ALREADY_CLOSED: 'Cash Drawer is already closed',
    INSUFFICIENT_BALANCE: 'Insufficient Balance',
    NO_LINKED_CASH_DRAWER: 'No linked cash drawer found with this POS',
    ASSIGNEE_NOT_FOUND: 'No employee found against this assigneeId',
    CLOSE_HOUSEDRAWER_LAST: 'Please ensure all other drawers are closed before closing the house drawer.',
  },
  CASH_DRAWER_LOGS: {
    CREATE_CASH_IN: 'Cash In creation failed',
    CREATE_CASH_OUT: 'Cash Out creation failed',
    CREATE_NO_SALE: 'No Sale creation failed',
    SERVER_NOT_FOUND: 'Server not found',
    OPERATOR_NOT_FOUND: 'Operator not found',
    INVALID_TYPE_OR_SUBTYPE_SELECTED: 'Invalid type or subtype selected',
    AMOUNT_MUST_BE_GREATER_THAN_ZERO: 'Amount must be greater than 0',
    AMOUNT_MUST_BE_POSITIVE: 'Amount must be a positive number',
    CASH_DRAWER_NOT_FOUND: 'Cash Drawer not found',
    CASH_DRAWER_CURRENT_AMOUNT_SHOULD_GREATER_THEN_AMOUNT: 'cash drawer current balance should be greater then amount',
    INVALID_AMOUNT: 'Invalid amount',
  },
  TIME_LOG: {
    ALREADY_CLOCKED_IN: 'Employee is already clocked in',
    CLOCKED_IN_WITH_DIFFERENT_ROLE: 'Employee is already clocked in with a different role',
    NOT_CLOCKED_IN: 'Employee is not clocked in',
    ALREADY_ON_BREAK: 'Employee is already on break',
    ALREADY_OFF_BREAK: 'Employee is already off break',
    EMPLOYEE_NOT_FOUND: 'Employee not found',
    ROLE_NOT_FOUND: 'Role not found',
    EMPLOYEE_ROLE_NOT_FOUND: 'Employee Role not found',
    RESTAURANT_NOT_FOUND: 'Restaurant not found',
    IN_BREAK: 'Employee cant clock out while on break',
    PENDING_TICKET: 'You have pending tickets',
    UNABLE_TO_END: 'Unable to End Break',
    UPDATE_TIME_CARD: 'Unable to Edit Time Entry',
    SHIFT_ENTRY_OVERLAP: 'Overlapping shift',
    PREVIOUS_SHIFT_OVERLAP: 'Cannot add time past close out',
    CLOCK_IN_VOLIATION: 'Cannot set the clock in time past the break time',
    CLOCK_OUT_VOLIATION: 'Cannot set the clock out time before the break time',
  },
  TIME_OFF: {
    INVALID_TIME_OFF_REQUEST: 'Invalid time off request',
    NOT_FOUND: 'Time off request not found',
    TIME_OFF_REQUEST_UPDATED_BY_ANOTHER_USER:
      'Time off request was updated by another user. Please refresh and try again.',
    TIMEOFF_REQUEST_CONFLICT: 'Timeoff requested already in given dates',
    INSUFFICIENT_LEAVE_BALANCE: 'Insufficient leave balance',
    TIME_OFF_DURATION: 'Timeoff duration must be greater than 0 day and less than or equal to 10 days',
    TIME_OFF_START_DATE_ERROR: 'TimeOff Start Date must be greater than or equal to the current date.',
    TIME_OFF_MAXIMUM_DATE: 'Timeoff cannot be requested beyond 365 days.',
    PENDING_REQUESTS_ALLOWED: 'Only pending requests can be edit or delete',
    NOT_ALLOWED: 'You are not allowed to perform this action',
  },
  TIMEOFF: {
    POLICY_ALREADY_EXISTS: 'Policy name already exists',
    POLICY_NOT_FOUND: 'Policy not found',
    POLICIES_NOT_FOUND: 'No policies found',
    USER_RESTAURANT_POLICY_NOT_FOUND: 'User restaurant policy not found',
    UNASSIGN_EMPLOYEES: 'Unassign employees before deleting this policy.',
    LEAVE_OVERVIEW_CONFLICT: 'Leave overview was updated by another user. Please refresh and try again.',
  },

  BREAK: {
    BREAK_NOT_FOUND: 'Break not found',
    BREAK_NOT_DUE_YET: 'Break not due yet',
    BREAK_NOT_WAIVABLE: 'Break not waibable',
    OVERLAPPING_BREAK_FOUND: 'This time is overlapped with another break time',
    TIME_NOT_PART_OF_SHIFT: 'This time is not part of your shift',
    BREAK_DURATION_EXCEEDS_CURRENT_TIME: 'Break duration based on this time exceeds current time',
  },
  ROLE: {
    INVALID_ROLE_TAG: 'Invalid Role Tag',
    ROLE_NOT_FOUND: 'Role not found',
    NOT_AUTHORIZED: 'You do not have access to view these roles',
  },
  AUTH_ROLE: {
    ROLE_NOT_FOUND: 'Role not found',
  },
  MODULE: {
    MODULE_NOT_FOUND: 'Module not found',
  },
  APP: {
    APP_NOT_FOUND: 'App not found',
  },
  FEATURE: {
    FEATURE_NOT_FOUND: 'Feature not found',
  },
  ROLE_FEATURE: {
    ROLE_FEATURE_NOT_FOUND: 'Role Feature not found',
  },
  USER_ROLE_FEATURE: {
    USER_ROLE_FEATURE_NOT_FOUND: 'User Role Feature not found',
  },
  USER_ROLE: {
    USER_ROLE_NOT_FOUND: 'User Role not found',
    ALREADY_DEFAULT: 'This role is already a default',
    NOT_AUTHORIZED: 'You do not have access to view user roles',
  },
  ROLE_PERMISSION: {
    ROLE_PERMISSION_NOT_FOUND: 'Role Permissions not found',
  },
  USER_RESTAURANTS: {
    USER_RESTAURANT_NOT_FOUND: 'User Restaurant not found',
    ALREADY_DEFAULT: 'This restaurant is already a default',
    NOT_AUTHORIZED: 'You do not have access to view user roles',
    ALREADY_EXISTS: 'This User Restaurant already exists.',
    RESTAURANT_INACTIVE: 'Restaurant is deactivated for this employee.',
    ALREADY_ACTIVE: 'Employee already activated',
    ALREADY_INACTIVE: 'Employee already inactive',
    ALREADY_INVITED: 'Employee has been invited',
  },
  APPROVAL: {
    APPROVAL_NOT_FOUND: 'Approval not found',
  },
  ONLINE_ORDERING_SETTINGS: {
    NOT_FOUND: 'Online Ordering Settings not found',
    ALREADY_EXISTS: 'Online Ordering Settings already exists',
    ALREADY_ENABLED: 'Online Ordering enabled already',
  },
  RESTAURANT: {
    RESTAURANT_NOT_CREATED: 'Unable to create restaurant',
    RESTAURANT_NOT_UPDATED: 'Unable to update restaurant',
    RESTAURANT_NOT_FOUND: 'Restaurant not found',
    NOT_FOUND: 'Restaurant not found',
    DEVICE_ALREADY_ONBOARDED: 'This device is already onboarded to a restaurant.',
    UNABLE_CLOSE_OUT: 'Unable to close out',
    INVALID_CLOSE_OUT_TIME: 'Invalid close out time',
    ALREADY_KIOSK_EXISTS: 'A KIOSK with the same name already exists',
    KDS_SERVER_CALL: 'Failed to send call to server',
    KDS_SERVER_USER_NOT_LOGGED_IN: 'User is not logged in',
    LOYALTY_NOT_ENABLED: 'Loyalty is not enabled',
    NUGGET_ALREADY_EXISTS: 'A Nugget with the same name already exists',
  },
  RESTAURANT_DEVICES: {
    NOT_FOUND: 'Restaurant Device Not Found',
    DEVICE_NOT_MAPPED: 'Device not mapped',
    INVALID_DEVICE_TYPE: 'Invalid device type',
    ALREADY_EXISTS: 'Restaurant Device already exists',
    DEVICE_TYPE_NOT_CONFIGURED: 'Missing configuration for this device type',
    MISSING_APP_NAME: 'App name value not found',
  },
  RESTAURANT_TIMING: {
    RESTAURANT_TIMING_NOT_FOUND: 'Restaurant Timing Not Found',
    RESTAURANT_CLOSED: 'Restaurant is closed',
  },
  BOOKMARK: {
    BOOKMARK_NOT_FOUND: 'Bookmark Not Found',
  },
  BUSINESS: {
    BUSINESS_NOT_FOUND: 'Business Not Found',
  },
  CARD: {
    CARD_NOT_FOUND: 'Card Not Found',
  },
  BANKACCOUNT: {
    NOT_FOUND: 'Bank Account Not Fount',
  },
  DISCOUNT: {
    NOT_FOUND: 'Discount Not Found',
    DISCOUNT_NOT_REMOVED: 'Discount not removed',
    DISCOUNT_NOT_CREATED: 'Discount not created',
    DISCOUNT_NOT_UPDATED: 'Discount not updated',
  },
  TAX: {
    NOT_FOUND: 'Tax Not Found',
  },
  POS: {
    ALREADY_EXISTS: 'POS already exists',
    POS_NOT_FOUND: 'POS Not Found',
  },
  IDEMPOTENCY: {
    CONFLICT_REQUEST: 'Request already processed',
  },
  KDS: {
    ALREADY_EXISTS: 'KDS already exists',
    NOT_FOUND: 'KDS not registered with restaurant',
  },
  kIOSK: {
    ALREADY_EXISTS: 'KIOSK already exists',
    NOT_FOUND: 'KIOSK not found',
  },
  KDC: {
    ALREADY_EXISTS: 'KDC already exists',
    NOT_FOUND: 'KDC not found',
  },
  INTERNAL_SERVER_ERROR: 'Internal Server Error',
  DB_QUERY_ERROR: 'Error while performing operation',
  BAD_REQUEST: 'Bad Request',
  INVALID_VALUE_PROVIDED: 'Invalid value provided',
  FILE: {
    FILE_UPLOAD_ERROR: 'File upload error',
    GET_FILE_ERROR: 'Get file error',
    NO_IMAGE_FILE_FOUND_ERROR: 'No image can be found',
    FETCHING_FILE_ERROR: 'Error while fetching files:',
    DELETEING_FILE_ERROR: 'Error deleting file error',
    FILE_UPDATE_FAILED: 'Error while updating file',
  },
  DAY_SCHEDULE: {
    DAY_SCHEDULE_GETTING_ERROR: 'Error while getting day schedule',
    DAY_SCHEDULE_CREATING_ERROR: 'Error while creating day schedule',
    DAY_SCHEDULE_UPDATING_ERROR: 'Error while updating day schedule',
    DAY_SCHEDULE_REMOVING_ERROR: 'Error while removing day schedule',
  },
  SETTING: {
    SETTING_GETTING_ERROR: 'Error while getting setting',
    SETTING_CREATING_ERROR: 'Error while creating setting',
    SETTING_UPDATING_ERROR: 'Error while updating setting',
    SETTING_REMOVING_ERROR: 'Error while removing setting',
  },
  VISIBILITY_SETTING: {
    VISIBILITY_SETTING_GETTING_ERROR: 'Error while getting visibility setting',
    VISIBILITY_SETTING_CREATING_ERROR: 'Error while creating visibility setting',
    VISIBILITY_SETTING_UPDATING_ERROR: 'Error while updating visibility setting',
    VISIBILITY_SETTING_REMOVING_ERROR: 'Error while removing visibility setting',
  },
  MODIFIER_GROUP: {
    MODIFIER_GROUP_NOT_FOUND: 'Modifier Group Not Found',
    MODIFIER_GROUPS_NOT_FOUND: 'Modifier Groups Not Found',
    MODIFIER_GROUP_NOT_REMOVED: 'Modifier Group Not Removed',
    MODIFIER_GROUP_NOT_CREATED: 'Modifier Group Not Created',
    MODIFIER_GROUP_NOT_UPDATED: 'Modifier Group Not Updated',
    MODIFIER_GROUP_FAILED: 'Modifier Group Failed',
  },
  SERVICE_CHARGE: {
    SERVICE_CHARGE_NOT_FOUND: 'Service charge not found',
    SERVICE_CHARGES_NOT_FOUND: 'Service charges not found',
    SERVICE_CHARGE_NOT_REMOVED: 'Service charge not removed',
    SERVICE_CHARGE_NOT_CREATED: 'Service charge not created',
    SERVICE_CHARGE_NOT_UPDATED: 'Service charge not updated',
    SERVICE_CHARGE_FAILED: 'Service charge failed',
  },
  INVENTORY: {
    INVENTORY: {
      INGREDIENT_DETAIL__NOT_FOUND: 'Inventory details not found',
      UN_AUTHORIZED: 'You are not authorized to view inventory',
    },
    INGREDIENT: {
      INGREDIENT_NOT_FOUND: 'Ingredient not found',
      INGREDIENT_LOGS_NOT_FOUND: 'Ingredient logs not found',
      INGREDIENT_NOT_DELETED: 'This ingredient cannot be deleted because it is used in one or more recipes.',
      INGREDIENT_SEARCH_NOT_MATCHED: 'No Ingredient matches the search criteria',
      UNABLE_CLOSE_OUT: 'Unable to close out',
      INGREDIENT_ALREADY_EXISTS: 'An Ingredient with the same name already exists',
      INSUFFICIENT_QUANTITY: 'Ingredient quantity is insufficient!',
      RESTAURANT_ID_IS_REQUIRED: 'Restaurant id is required',
      RECIPE_ID_IS_REQUIRED: 'recipe id is required',
      RECIPE_ID_AND_MENUID_IS_REQUIRED: 'recipe id and menu item id is required',
    },
    STOCK_ADJUSTMENT: {
      UNFINISHED_ADJUSTMENT: 'There is already an unfinished stock adjustment for this storage area.',
      USER_RESTAURANT_NOT_FOUND: 'User restaurant association not found.',
      ADJUSTMENT_NOT_FOUND: 'Stock Adjustment with the provided ID was not found.',
      INGREDIENTS_RECIPES_RETRIEVAL_FAILED: 'Failed to retrieve ingredients and recipes for the storage area.',
      STOCK_ADJUSTMENT_CREATION_FAILED: 'Error while creating Stock Adjustment.',
      STOCK_ADJUSTMENT_UPDATE_FAILED: 'Error while updating Stock Adjustment.',
      STOCK_ADJUSTMENT_DELETE_FAILED: 'Failed to delete Stock Adjustment.',
      GENERAL_ERROR: 'An internal server error occurred.',
      NOT_FOUND: 'The requested resource was not found.',
      STORAGE_AREA_NOT_FOUND: 'storage area not found',
      INVALID_REASON: 'Invalid reason for stock adjustment',
      ONE_FAILED_MANDATORY: 'Either ingredientId or prepRecipeId must be provided, but not both empty',
      STORAGE_AREA_EMPTY: 'Storage area is empty',
    },
    UNIT: {
      UNIT_NOT_FOUND: 'Unit not found',
      UNIT_CONVERSIONS_NOT_FOUND: 'Unit conversions not found',
      MISSING_FROM_UNIT_ID: 'From unit ID is required',
      UNIT_SEARCH_NOT_MATCHED: 'No Unit matches the search criteria',
      UNABLE_CLOSE_OUT: 'Unable to close out',
      UNIT_ALREADY_EXISTS: 'A Unit with the same name already exists',
      ALREADY_USED: 'Unit is already in use with other ingredient(s) and cannot be removed',
    },
    VENDOR: {
      VENDOR_NOT_FOUND: 'Vendor not found',
      VENDOR_SEARCH_NOT_MATCHED: 'No vendor matches the search criteria',
      UNABLE_CLOSE_OUT: 'Unable to close out',
      VENDOR_ALREADY_EXISTS: 'A Vendor with the same name already exists',
    },
    ORDER: {
      ORDER_NOT_FOUND: 'Order not found',
      ORDER_SEARCH_NOT_MATCHED: 'No Order matches the search criteria',
      UNABLE_CLOSE_OUT: 'Unable to close out',
      ORDER_ALREADY_EXISTS: 'An Order with the same name already exists',
      INVALID_STATUS: 'Invalid status in the input has been given',
      ORDER_ALREADY_RECEIVED: 'This order has already been received and cannot be canceled once processed',
    },
    CHART_OF_ACCOUNTS: {
      COA_NOT_FOUND: 'Chart of account not found',
      COA_SEARCH_NOT_MATCHED: 'No Chart of account matches the search criteria',
      UNABLE_CLOSE_OUT: 'Unable to close out',
      COA_ALREADY_EXISTS: 'A Chart of account with the same name already exists',
    },
    INVOICE: {
      INVOICE_NOT_FOUND: 'Invoice not found',
      INVOICE_SEARCH_NOT_MATCHED: 'No Invoice matches the search criteria',
      UNABLE_CLOSE_OUT: 'Unable to close out',
      INVOICE_ALREADY_EXISTS: 'An Invoice with the same name already exists',
      INVOICE_NUMBER_REQUIRED: 'Invoice number cannot be empty',
      INVOICE_ALREADY_EXIST_PENDING_STATE: 'Invoice with the same order id already exists',
    },
    RECIPE: {
      RECIPE_NOT_FOUND: 'Recipe not found',
      RECIPE_LOG_MISSING_REQUIRED_PARAMETERS: 'Missing required parameters',
      RECIPE_SEARCH_NOT_MATCHED: 'No Recipe matches the search criteria',
      UNABLE_CLOSE_OUT: 'Unable to close out',
      RECIPE_ALREADY_EXISTS: 'A Recipe with the same name already exists',
    },
    WASTAGE_LOG: {
      INVALID_DATES: 'End date cannot be before start date',
      INVENTORY_OUT_OF_SYNC: 'Inventory out of sync',
      ITEM_NOT_FOUND: 'Inventory item not found',
    },
  },
  WEB_BUILDER: {
    WEB_BUILDER_NOT_FOUND: 'Web Builder data Not Found',
    WEB_BUILDER_NOT_CREATED: 'Web Builder data Not Created',
    WEB_BUILDER_ALREADY_EXIST: 'Web Builder data already exists with the restaurantId and businessId',
    WEB_BUILDER_NOT_UPDATED: 'Web Builder data Not Updated',
    WEB_BUILDER_NOT_DELETED: 'Web Builder data Not Deleted',
    WEB_BUILDER_GET_FAILED: 'Web Builder data GET Failed',
    WEB_BUILDER_PUBLISH_FAILED: 'Website Publish Failed',
    WORKFLOW_RUN_NOT_FOUND: 'Workflow run not found',
    WEBSITE_SERVER_CONFIG_NOT_FOUND: 'Website server config not found',
    WEBSITE_DOMAIN_NOT_FOUND: 'Website domain not found',
  },
  WEBSITE_SEO: {
    SEO_DATA_NOT_UPDATED: 'SEO data not updated',
    SEO_DATA_NOT_FOUND: 'SEO data not found',
    SEO_DATA_NOT_CREATED: 'SEO data not created',
    SEO_DATA_NOT_DELETED: 'SEO data not deleted',
    SEO_DATA_GET_FAILED: 'SEO data GET Failed',
  },
  DOMAIN_SETTINGS: {
    DOMAIN_SETTINGS_NOT_UPDATED: 'Domain settings not updated',
    DOMAIN_ALREADY_EXISTS: 'Domain already exists',
    DOMAIN_SETTINGS_NOT_FOUND: 'Domain settings not found',
    DOMAIN_SETTINGS_NOT_CREATED: 'Domain settings not created',
    DOMAIN_SETTINGS_NOT_DELETED: 'Domain settings not deleted',
    DOMAIN_SETTINGS_GET_FAILED: 'Domain settings GET Failed',
    DOMAIN_NOT_VERIFIED: 'Domain is not verified',
    SSL_NOT_VALID: 'SSL is not valid',
  },
  ACTIVE_ANNOUNCEMENT: {
    ACTIVE_ANNOUNCEMENT_NOT_UPDATED: 'Active Announcement not updated',
    ACTIVE_ANNOUNCEMENT_NOT_FOUND: 'Active Announcement not found',
    ACTIVE_ANNOUNCEMENT_NOT_CREATED: 'Active Announcement not created',
    ACTIVE_ANNOUNCEMENT_NOT_DELETED: 'Active Announcement not deleted',
    ACTIVE_ANNOUNCEMENT_GET_FAILED: 'Active Announcement GET Failed',
  },
  GIFT_CARD: {
    CUSTOMER_LINKAGE: 'Customer Linkage Failed',
    TOKEN_INVALID: 'invalid token',
    INCORRECT_NUMBER_ENTERED: 'Incorrect number entered',
    INCORRECT_PIN_ENTERED: 'Incorrect pin entered',
    GIFT_CARD_EXPIRED: 'Gift card has been expired',
    INVALID_CARD: 'Invalid Gift Card',
    INVALID_PIN: 'Invalid Gift Card Pin',
    PIN_REQUIRED: 'Gift card pin is required.',
    CARD_NUMBER_REQUIRED: 'Gift card number is required.',
    GIFT_CARD_APPLIED_ON_TICKET: 'Gift Card is already applied on this ticket',
    CREDENTIALS_NOT_PROVIDED: 'Gift Card credentials not provided',
    INSUFFICIENT_BALANCE: 'Insufficient balance on Gift Card',
    FAILED_TO_REDEEM: 'Failed to redeem gift card',
    NOT_FOUND_DB: 'Gift Card not found in DB',
    FAILED_TO_LOAD_BALANCE: 'Failed to load funds to gift card',
    NUMBER_REQUIRED: 'Gift card number is required.',
    NUMBER_LESS_THAN_19_DIGITS: 'Gift card number must be less than or equal 19 digits.',
    TEMPLATE_CATEGORY_NOT_FOUND: 'Gift card template category not found',
    TEMPLATE_CATEGORY_ALREADY_EXISTS: 'Gift card template category name already exists',
    TEMPLATE_CATEGORY_UPDATED_SUCCESSFULLY: 'Gift card template category updated successfully',
    TEMPLATE_CATEGORY_NAME_REQUIRED: 'Gift card template category name is required',
    TOPUP_PARTIAL_FAIL: 'Failed to top-up some cards',
    TRANSFER_FAILED: 'Failed to transfer balance',
    SAME_CARD_TRANSFER: 'Cannot transfer to the same card',
    AMOUNT_REQUIRED: 'Amount is required.',
    CREDENTIALS_NOT_FOUND: 'Gift card credentials not found from db',
  },
  GIFT_CARD_TICKET: {
    TICKET_NOT_CREATED: 'Gift Card Ticket Not Created',
    TICKET_NOT_FOUND: 'Gift Card Ticket Not Found',
    TICKET_ALREADY_PAID: 'Gift Card Ticket Already Paid',
    BALANCE_NOT_ADDED: 'Gift Card Balance Not Updated',
    PURCHASE_FAILED: 'Gift Card Purchase Failed',
  },
  JWT: {
    TOKEN_EXPIRE: 'jwt expired',
    TOKEN_INVALID: 'invalid token',
  },
  WEBSITE_FORMS: {
    FORM_SUBMISSION_FAILED: 'Form submission failed',
    FORM_NOT_FOUND: 'Form not found',
    FORM_FETCH_FAILED: 'Form fetch failed',
  },
  AI_AUTO_REPLY: {
    LIMIT_EXCEED: 'AI response limit exceeded',
    UNABLE_TO_GENERATE: 'TRY AGAIN LATER',
  },
  NUGGET_MENU: {
    NUGGET_MENU_NOT_FOUND: 'Nugget Menu Not Found',
    NUGGET_MENU_NOT_REMOVED: 'Nugget Menu Not Removed',
    NUGGET_MENU_NOT_CREATED: 'Nugget Menu Not Created',
    NUGGET_MENU_NOT_UPDATED: 'Nugget Menu Not Updated',
  },
  FEATURED_AD: {
    FEATURED_AD_NOT_FOUND: 'Featured Ad Not Found',
    FEATURED_AD_LIST_NOT_FOUND: 'Featured Ad List Not Found',
    FEATURED_AD_NOT_REMOVED: 'Featured Ad Not Removed',
    FEATURED_AD_NOT_CREATED: 'Featured Ad Not Created',
    FEATURED_AD_NOT_UPDATED: 'Featured Ad Not Updated',
  },
  NUGGET: {
    ALREADY_EXISTS: 'Nugget already exists',
    NOT_FOUND: 'Nugget not found',
    INCORRECT_TABLE_BINDING: 'Incorrect table mapping or table not found',
    CONFIGURATION_ALREADY_EXISTS: 'Nugget configuration already exists for this restaurant',
  },
  SETTINGS: {
    SETTINGS_NOT_FOUND: 'Settings not found',
  },
  AIO_ASSISTANCE: {
    AI_NOT_RESPOND: 'AI not responding',
    RESPONSE_NOT_FOUND: 'Response not found',
    QUESTION: 'Something wrong to generate answer',
  },
  RECIPE: {
    SEQUENCE_NOT_FOUND: 'No matching record found for ',
    UPDATE_FAILED: 'Internal server error. Sorting failed.',
    NOT_FOUND: 'Some items not found.',
  },
  MOM_NOTIFICATION: {
    RESTAURANT_ID_REQUIRED: 'Both userId and restaurantId are required.',
    UNAUTHORIZED: 'You are not authorized to update this notification',
    NOT_FOUND: 'Notification not found',
  },

  FIREBASE: {
    UNAUTHORIZED_TO_GET_TOKEN: 'You are not authorized to get firebase token',
    UNAUTHORIZED_TO_UPDATE_APP_VERSION: 'You are not authorized to update app version',
    UNAUTHORIZED_TO_GET_APP_VERSION: 'You are not authorized to get app version',
    UNKNOWN_WRITE_ERROR: 'Unknown error occurred while writing to Firebase',
    DUPLICATE_APP_INIT: 'Firebase app already initialized',
    NETWORK_ERROR: 'Network error: Unable to connect to Firebase Database',
    PERMISSION_DENIED: 'Firebase permission denied: Check your security rules',
    INVALID_DATA: 'Invalid data: Could not serialize input',
    QUOTA_EXCEEDED: 'Firebase quota exceeded: Too many writes',
    INTERNAL_ERROR: 'Internal Firebase error',
    CUSTOM_TOKEN_CREATION_FAILED: 'Failed to create custom Firebase token',
    INVALID_UID: 'Invalid UID provided for Firebase token generation',
    INVALID_CLAIMS: 'Invalid custom claims provided for Firebase token generation',
    INVALID_VERSION: 'Invalid version',
    INVALID_APK_URL: 'Invalid apk url',
    TEAM_NAME_INCORRECT: 'Team name is incorrect',
  },
  GENERIC_MSG: {
    RESTAURANT_ID_REQUIRED: 'Restaurant id is required.',
    USER_ID_REQUIRED: 'user id is required.',
    USER_AND_RESTAURANT_ID_REQUIRED: 'UserId and restaurantId are required.',
    BUSINESS_ID_REQUIRED: 'businessId is required',
    EMPLOYEE_ID_REQUIRED: 'employeeId is required',
  },
  GUEST_HELP_REQUEST: {
    NOT_FOUND: 'Guest help request not found',
    ALREADY_RESOLVED: 'Guest help request is already resolved',
    ALREADY_TRIGGERED: 'Guest help request is already triggered',
  },
  TIP_MANAGER: {
    PAYCHECK: 'Tips cannot be paid with paycheck',
    PENDING_PENDING_FAILED: 'Could not retrieve pending tips. Please try again',
    PENDING_AMOUNT_EXCEED: 'Amount must not exceed the available pending tip',
  },
  ORDER_DELAY: {
    ORDER_DELAY_NOT_FOUND: 'Order delay not found',
  },
  AVG_PREP_TIME: {
    PREP_TIME_NOT_FOUND: 'Settings not found',
  },
  PAYROLL: {
    PAYROLL_DOES_NOT_EXIST: 'Payroll does not exist',
    PAYROLL_ONLY_EDIT_IN_DRAFT: 'Payroll can only be edited in draft mode',
    NO_EMPLOYEE_DATA: 'At least one employee must exist in the payroll',
    MISSING_WORKPLACE: 'workplace id is missing in restaurant',
  },
  DEVICE_STATUS: {
    NOT_FETCHED: 'Failed to get devices',
    HEARTBEAT: 'Failed to send heartbeat',
    ACKNOWLEDGE: 'Failed to acknowledge',
  },
  THIRD_PARTY_INTEGRATION: {
    NOT_FOUND: 'Store with partner name not found',
    SETTING_MISSING: 'Store settings missing',
    SETTING_UNAVAILABLE_FOR_STORE: 'Setting for this store is not available',
    DELIVERY_IS_NOT_ENABLED: 'Door dash delivery is not enabled',
    DOORDASH_CREATE_QUOTE_FAILED: 'Create delivery quote failed',
    DOORDASH_ACCEPT_QUOTE_FAILED: 'Accpet delivery quote failed',
    UPDATE_DOORDASH_DELIVERY_FAILED: 'Failed to update DoorDash delivery',
    GET_DOORDASH_DELIVERY_FAILED: 'Failed to get doorDash deliveries',
  },
};
export const EMPLOYEE_BREAK_STATUS = {
  NOT_TAKEN: 'The user has not taken the breaks',
  PARTIALLY_TAKEN: 'The user has taken the breaks partially',
  ALL_TAKEN: 'All Breaks Taken',
  NOT_APPLICABLE: 'Breaks Waived or not applicable',
  BREAK_LAWS_NOT_APPLICABLE: 'Breaks laws not applicable',
};

export const TENANT_HEADER = 'x-tenant-id';
export const ID_TOKEN_HEADER = 'x-id-token';
export const JWT_TOKEN_HEADER = 'x-jwt-token';
export const APP_HEADER = 'x-app-name';
export const DEVICE_HEADER = 'x-device-id';
export const CRYPTO_HEADER = 'x-crypto-payload';
export const DEVICE_HASH = 'x-device-hash';
export const RESTAURANT_ID = 'restaurant-id';

export const COSMICJOBS_CONSTANTS = {
  EMPLOYEE_TIMECARD_DEFAULT_MAILS:
    'abdul.wahab@aioapp.com,aitzaz.ahmad@aioapp.com,hina.kanwal@aioapp.com,ammar.mashood@aioapp.com',
};

export const ORDER_CANCEL_REASON = [
  { id: 1, reason: 'Customer changed their mind' },
  { id: 2, reason: 'Order placed by mistake' },
  { id: 3, reason: 'Item out of stock' },
  { id: 4, reason: 'Training/testing' },
  { id: 5, reason: 'Wrong item selected' },
  { id: 6, reason: 'Billing error' },
  { id: 7, reason: 'Server error' },
  { id: 8, reason: 'Other' },
];

export const CACHE_MANAGER_KEYS = {
  RESTAURANT: {
    RESTAURANT_BY_ID: 'restaurant-by-id',
  },
};

export const REDIS_DATA_KEYS = {
  TIMELOG: 'timelog',
  PENNDING_BREAK: 'pending_break',
  BREAK_INFO: 'break_info',
  COGNITO_DATA: 'cognito_data',
  MANAGER_APPROVAL_TOKEN: 'managerApprovalToken',
  SECONDS_IN_AN_HOUR: 60 * 60,
  SECONDS_IN_A_DAY: 24 * 60 * 60,
  SECONDS_IN_A_7_DAY: 7 * 24 * 60 * 60,
  SECONDS_IN_60_DAYS: 60 * 24 * 60 * 60,
  SECONDS_IN_10_MINUTES: 10 * 60,
};

export const SHORT_POLL_TIME = {
  minute: 60000,
  halfSec: 500,
};

export const CART_FIELDS_CLAUSE = {
  session: 'session',
  phone: 'phone',
};

export const AIO_APPS = {
  online_app: 'online',
};

export const DEFAULT_LIMITS = {
  TAKE: 50,
  SKIP: 0,
  FAVORITE_ITEMS_API_LIMIT: 4,
};

export const DEFAULT_ROWS = {
  SERVICE_CHARGES_ID: 'ca_living_wage',
};
export const GRATUNITY_CHARGES = {
  GRATUNITY_CHARGES_ID: ['ca_living_wage', 'large_party'],
};
export const LARGE_PARTY = 'large_party';
export const AVG_WEEKS_IN_MONTH = 4.34524;
export const AVG_DAYS_IN_MONTH = 30.436875;
export const AVG_FORTNIGHTS_IN_MONTH = 2.17262;
export const STRIPE_ERRORS = {
  StripeCardError: 'StripeCardError',
  StripeInvalidRequestError: 'StripeInvalidRequestError',
  StripeAPIConnectionError: 'StripeAPIConnectionError',
  StripeAPIError: 'StripeAPIError',
  StripeAuthenticationError: 'StripeAuthenticationError',
  StripeIdempotencyError: 'StripeIdempotencyError',
  StripePermissionError: 'StripePermissionError',
  StripeRateLimitError: 'StripeRateLimitError',
  StripeSignatureVerificationError: 'StripeSignatureVerificationError',
};
export const WORKING_HOURS_PER_WEEK = {
  FIXED: {
    REGULAR: 56,
    OVERTIME_DURATION: 28,
    OVERTIME: 84,
  },
  HOURLY: {
    REGULAR: 40,
    OVERTIME_DURATION: 20,
    OVERTIME: 60,
  },
};

export const WORKING_HOURS_PER_DAY = {
  REGULAR: 8,
  OVERTIME_DURATION: 4,
  OVERTIME: 12,
};

export const MODULES = {
  CLOCK_IN: 1,
  TABLE_LAYOUT: 2,
  MENU: 3,
  PAYMENT: 4,
  TICKET: 5,
  HEADER: 6,
  DASHBOARD: 7,
  CASHDRAWER: 8,
  INVENTORY_VENDOR: 9,
};

export enum Pizza_Sides {
  FULL = 'full',
  LEFT = 'left',
  RIGHT = 'right',
}

export const DEV_ENVIRONMENTS = ['internal', 'qa', 'uatv2'];

export const MANAGER_ROLE_KEYS = ['general-manager', 'shift-or-assistant-manager', 'manager', 'owner'];

export const OPERATIONS = {
  ACCESS: 'access',
};

export const DEFAULT_TIMEOUTS = {
  COGNITO_VERIFIER: 10000,
};

export const prepTime = [
  {
    value: 10,
    maxValue: true,
  },
  {
    value: 20,
    maxValue: true,
  },
  {
    value: 30,
    maxValue: true,
  },
  {
    value: 30,
    minValue: true,
  },
];

export const restaurantMenuList = [
  {
    label: 'Home',
    link: '/online-ordering/1',
  },
  {
    label: 'My Orders',
    link: '/my-orders',
  },
];

export const MENU = {
  POPULAR_ITEMS: {
    MINIMUM_ORDERS: 1,
    LIMIT: 4,
  },
  FAVORITE_ITEMS: {
    LIMIT: 2,
  },
};
const weCollect = 'We collect';
const personalInfo = 'Personal Information';

export const PRIVACY_POLICY = [
  {
    title: '1. INTRODUCTION',
    paragraphs: [
      'a) AIOApp Inc. ("we," "us," or "AIO") places significant importance on respecting and safeguarding the privacy of individuals.',
      'b) This Privacy Policy outlines our commitment to complying with data protection laws, referred to as the "Data Protection Legislation". This Privacy Policy explains our procedures for collecting, using, storing, and disclosing personal information of individuals. The term "Personal Information" refers to data about identifiable individuals or information that, when combined with other data, can identify an individual.',
      'c) AIO\'s services involve providing organizations and individuals within those organizations (referred to as "Customers") with access to and use of AIO Services. These services enable Customers and their staff members to manage various tasks through their devices ("Devices").',
      'd) AIO may update this Privacy Policy periodically. Check this page for updates, as we will post any changes here. Individuals affected by material changes will be notified.',
    ],
  },
  {
    title: `2. OUR COLLECTION AND USE OF ${personalInfo.toUpperCase()}`,
    paragraphs: [
      `a) Customer Data: Our primary purpose for collecting and using ${personalInfo} is to provide Services to our Customers. When processing ${personalInfo} on behalf of Customers, we are a service provider/data processor. We use Customer Data for service improvement on an aggregated and non-identifiable basis. `,
      'b) Customers are responsible for complying with privacy laws when using the Services and obtaining appropriate consent. ',
      `c) AIO Data: We collect, use, and disclose ${personalInfo.toLowerCase()} from individual users (not linked to a Customer) for our own purposes. This data is referred to as "AIO Data." `,
    ],
  },
  {
    title: `3. WHAT KIND OF ${personalInfo.toUpperCase()} DO ${weCollect.toUpperCase()} AND USE? `,
    paragraphs: [
      `${weCollect} various  to provide Services, including but not limited to name, address, phone numbers, email address, payment information, social security number, tax information and log data from Devices. `,
    ],
  },
  {
    title: `4. HOW DO ${weCollect.toUpperCase()} YOUR ${personalInfo.toUpperCase()}?`,
    paragraphs: [
      `${weCollect} ${personalInfo} through account registration, communication with customer organizations, third-party integrations, data inputted by users, and automatic collection from devices or our website. `,
    ],
  },
  {
    title: '5. WEBSITE INFORMATION ',
    paragraphs: [
      `${weCollect} limited ${personalInfo} from website users to improve user experience, manage services, and understand website activity. This may include log data, information searched on the website, and details provided when contacting us. `,
    ],
  },
  {
    title: '6. MARKETING',
    paragraphs: [
      `With consent, we use ${personalInfo} to send marketing communications. Users can unsubscribe from marketing materials. Transactional and account-related communications may still be received after unsubscribing. `,
    ],
  },
  {
    title: '7. INFORMATION SHARING & DISCLOSURE',
    paragraphs: [
      `We share ${personalInfo} with service providers, and third-party applications with consent, and for legal compliance. Business transfers may involve transferring ${personalInfo}. `,
    ],
  },
  {
    title: `8. HOW DO WE SAFEGUARD YOUR ${personalInfo.toUpperCase()}? `,
    paragraphs: [
      `We employ technical and organizational measures to protect ${personalInfo} from misuse or unauthorized access. Access is restricted to employees and authorized service providers based on need. `,
    ],
  },
  {
    title: `9. HOW LONG DO WE KEEP YOUR ${personalInfo.toUpperCase()} FOR? `,
    paragraphs: [
      `We retain ${personalInfo} as long as necessary under our agreement with Customers or as required by law. Data is deleted or anonymized when no longer needed. `,
    ],
  },
  {
    title: `10. HOW CAN YOU ACCESS OR AMEND THE ${personalInfo.toUpperCase()} WE HOLD ABOUT YOU?`,
    paragraphs: [
      `Individuals have the right to access, update, and correct inaccuracies in their ${personalInfo}. Requests can be made by contacting us.`,
    ],
  },
  {
    title: `11. HOW DO WE STORE AND TRANSFER YOUR ${personalInfo.toUpperCase()} INTERNATIONALLY? `,
    paragraphs: [
      `${personalInfo} may be processed outside the jurisdiction of residence. Data transfers are encrypted securely, and service providers comply with privacy laws. `,
    ],
  },
  {
    title: '12. PRIVACY RIGHTS FOR CALIFORNIA RESIDENT ',
    paragraphs: [
      `California residents have privacy rights under the California Consumer Privacy Act (CCPA), including the right to request disclosure, deletion, and information on the sale of ${personalInfo.toLowerCase()}. Requests can be submitted via mail, email, or phone. `,
    ],
  },
  {
    title: `13. WHO IS RESPONSIBLE FOR PROCESSING YOUR ${personalInfo.toUpperCase()} AND CONTACT INFORMATION? `,
    paragraphs: [],
  },
];

export const PrivacyTable = [
  {
    categories: [
      {
        name: 'Identifiers',
        sources: ['You', 'Third party social media companies', 'Cookies and tracking technologies'],
        purpose: [
          'Improve services',
          'Personalize user experiences',
          'Communicate with users',
          'Marketing & advertisement',
          'Customer service',
          'Compliance with applicable law',
        ],
        disclosed_for_business_purposes: [
          'Service providers',
          'Affiliates',
          'Law enforcement and government agencies as required by law or in connection with court proceedings',
        ],
        sold_or_shared_for_cross_contextual_advertising: ['N/A'],
      },
      {
        name: 'Any categories of Personal Information described in Section 1798.140',
        sources: ['You', 'Cookies and tracking technologies'],
        purpose: [
          'Enable user to enjoy our Services at full functionality',
          'Offer personalized experience of Services',
          'Administer the quality of our Services',
          'To communicate with users',
        ],
        disclosed_for_business_purposes: [
          'Service providers who enable us to provide Services',
          'Law enforcement and Government agencies as required by law or in connection with court proceedings',
        ],
        sold_or_shared_for_cross_contextual_advertising: ['N/A'],
      },
      {
        name: 'Any categories of Personal Information described in Section 1798.140',
        sources: ['You', 'Cookies and tracking technologies'],
        purpose: [
          'Enable user to enjoy our Services at full functionality',
          'Offer personalized experience of Services',
          'Administer the quality of our Services',
          'To communicate with users',
          'Marketing and Advertising',
          'Research and development of our Services',
        ],
        disclosed_for_business_purposes: [
          'Service providers who enable us to provide Services',
          'Law enforcement and Government agencies as required by law or in connection with court proceedings',
        ],
        sold_or_shared_for_cross_contextual_advertising: ['N/A'],
      },
      {
        name: 'Commercial Information',
        sources: [
          'You',
          'Third-party social media companies',
          'Third party Merchants such as data analytics providers, identity verification services & financial institutions',
        ],
        purpose: ['Enable the process of restaurant onboarding'],
        disclosed_for_business_purposes: [
          'Third-party service providers such as financial institutions and those who enable the underwriting process',
        ],
        sold_or_shared_for_cross_contextual_advertising: ['N/A'],
      },
      {
        name: 'Geo location Data',
        sources: ['You', 'Sources such as GPS, Bluetooth, or internet connectivity'],
        purpose: ['Address for delivery', 'Offer personalized services'],
        disclosed_for_business_purposes: ['Third-party service Providers who enable us to provide Services'],
        sold_or_shared_for_cross_contextual_advertising: ['N/A'],
      },
      {
        name: 'Inferences',
        sources: [
          'You',
          'Cookies and Tracking Technologies',
          'Third-party social media companies',
          'Third-party Merchants, such as data analytics providers, and advertising networks.',
        ],
        purpose: ['Offer and monitor our services'],
        disclosed_for_business_purposes: ['Third-party service Providers who enable us to provide Services'],
        sold_or_shared_for_cross_contextual_advertising: ['N/A'],
      },
      {
        name: 'Professional or Employment Information',
        sources: ['You', 'Team, affiliates and related entities'],
        purpose: ['Merchant Employees (using Payroll)'],
        disclosed_for_business_purposes: ['Law enforcement and Government agencies as required by law'],
        sold_or_shared_for_cross_contextual_advertising: ['N/A'],
      },
    ],
  },
];

export const TS_Vector = {
  LANG: 'english',
  SIMPLE: 'simple',
};

export const defaultTimeZone = 'America/New_York';
export const DEFAULT_RESTAURANT = 1;
export const MAX_ALLOWED_CUSTOM_VAULT_CATEGORIES = 4;

export const LOCAL_STORAGE = {
  MARKETING: {
    GUESTBOOK: {
      GUESTBOOK_FILTERS: 'guestbook_params',
    },
    REVIEW_MANAGEMENT: {
      DURATION: 'REVIEW_DURATION',
    },
  },
  MENU_BOARD: {
    PLAYLIST: {
      PLAYLIST_ITEM: 'PLAYLIST_ITEM',
    },
  },
  INTEGRATIONS: {
    TIKTOK_CSRF: 'TIKTOK_CSRF',
    YELP_CSRF: 'YELP_CSRF',
  },
};

export const ADVISORY_LOCK_ID = 1;
export const ADVISORY_MAX_RETRIES = 3;
export const ADVISORY_RETRY_DELAY = 3000;

export const MQTT_TOPIC_FORMAT = 'restaurant/';

export const QUEUE_NAME = process.env['QUEUE_NAME'] ? process.env['QUEUE_NAME'] : 'aio-queue-uat';
export const ANALYTICS_QUEUE_NAME = process.env['ANALYTICS_QUEUE_NAME']
  ? process.env['ANALYTICS_QUEUE_NAME']
  : 'analytics-queue';
export const CAMPAIGN_QUEUE_NAME = process.env['CAMPAIGN_QUEUE_NAME']
  ? process.env['CAMPAIGN_QUEUE_NAME']
  : 'aio_queue_campaign';
export const DEAL_QUEUE_NAME = process.env['DEAL_QUEUE_NAME'] ? process.env['DEAL_QUEUE_NAME'] : 'aio_queue_deal';
export const CONTENT_CHEF_QUEUE_NAME = process.env['CONTENT_CHEF_QUEUE_NAME'] ?? 'content-chef-queue';
export const JOURNEY_QUEUE_NAME = process.env['JOURNEY_QUEUE_NAME']
  ? process.env['JOURNEY_QUEUE_NAME']
  : 'aio_queue_journey';
export const MQTT_QUEUE_NAME = process.env['MQTT_QUEUE_NAME'] ? process.env['MQTT_QUEUE_NAME'] : 'aio_queue_mqtt';
export const TRIANGULUMNOVA_QUEUE_NAME = process.env['TRIANGULUMNOVA_QUEUE_NAME'];
export const INVENTORY_QUEUE_NAME = process.env['INVENTORY_QUEUE_NAME']
  ? process.env['INVENTORY_QUEUE_NAME']
  : 'accouting-queue.fifo';
export const GIFT_CARD_INVENTORY_QUEUE_NAME = process.env['GIFT_CARD_INVENTORY_QUEUE_NAME']
  ? process.env['GIFT_CARD_INVENTORY_QUEUE_NAME']
  : 'giftcard_inventory_queue';
export const ARM_QUEUE_NAME = process.env['ARM_QUEUE_NAME'] ? process.env['ARM_QUEUE_NAME'] : 'aio_queue_arm_reviews';
export const ACTIVITY_LOG_QUEUE_NAME = process.env['ACTIVITY_LOG_QUEUE_NAME']
  ? process.env['ACTIVITY_LOG_QUEUE_NAME']
  : 'aio_queue_activity_log';
export const ARM_REVIEWS_AI_NAME = process.env['ARM_STORE_REVIEWS_AI_QUEUE_NAME']
  ? process.env['ARM_STORE_REVIEWS_AI_QUEUE_NAME']
  : 'aio_queue_arm_reviews_ai_dev';
export const CHECK_HQ_WEBHOOKS = {
  STATUS_CHANGE: 'status_change',
  EVENTS: {
    UPDATED: 'updated',
    CREATED: 'created',
  },
  CHECK_TOPICS: {
    EMPLOYEE: 'employee',
    PAYROLL: 'payroll',
    RESTAURANT: 'workplace',
    BUSINESS: 'company',
  },
  EMPLOYEE_ONBOARDING_STATUS: {
    COMPLETED: 'completed',
    NEEDS_ATTENTION: 'needs_attention',
    BLOCKING: 'blocking',
  },
} as const;

export const VISIBILITY_SETTING_ALIAS = {
  ITEM: {
    ALIAS: 'i',
    SETTING: 's_item',
    VISIBILITY_SETTING: 'vs_item',
    DAY_SCHEDULE: 'ds_item',
  },
  CATEGORY: {
    ALIAS: 'c',
    SETTING: 's_category',
    VISIBILITY_SETTING: 'vs_category',
    DAY_SCHEDULE: 'ds_category',
  },
  MENU: {
    ALIAS: 'm',
    SETTING: 's_menu',
    VISIBILITY_SETTING: 'vs_menu',
    DAY_SCHEDULE: 'ds_menu',
  },
};

export const DEFAULT_OVERTIME_RATES = {
  OVERTIME: 1.5,
  DOUBLE_OVERTIME: 2,
};

export const MAX_DURATION = 86399; // 23:59:59 in seconds
export const CHANGE_OF = 1; // Increment or Decrement of 1 seconds with limit

export const BUll_DEFAULT_QUEUE_OPTIONS = {
  connectionOptions: {
    enableOfflineQueue: false,
    enableReadyCheck: true,
    reconnectOnError: (err: any) => {
      // eslint-disable-next-line no-console
      console.error(`Redis Error Occured: ${err.message}`, err);
      return true;
    },
    maxRetriesPerRequest: 1,
  },
  defaultJobOptions: {
    attempts: parseInt(process.env['QUEUE_RETRY_ATTEMPTS'] || '5'),
    backoff: { type: 'fixed', delay: parseInt(process.env['QUEUE_RETRY_DELAY'] || '5000') },
    removeOnComplete: true,
    removeOnFail: { age: 8 * 3600, count: 1000 },
    delay: 0,
  },
  queuePrefix: 'aio',
};

export const TWILIO_MSGID_POST_ORDER = 'MG58785f848c608a2e031afc71b84873f3';

export const TWILIO_MSGID_OTP = 'MG4606a11a86a80fb2fa4f7a5d1ab1c9e0';

export const TWILIO_MSGID_SMS_RECEIPT = 'CM63e59e54b09476113f5b9fa00fd39812';

export const NEW_RELIC_JOBS_IDENTIFIERS = {
  GRAVITON_JOB: 'Graviton Job',
  TICKET_QUEUE_SUBSCRIBER: 'Ticket queue subscriber',
  TICKET_QUEUE_PROCESSOR: 'Ticket queue processor',
  GRAVITON_CRON_JOB: 'Graviton cron job',
  CLOSEOUT_JOB: 'Closeout Job',
  DELETE_AUDIT_LOGS: 'Delete auditlogs',
  DELETE_CRON_JOB_LOGS: 'Delete cronJoblogs',
  DELETE_KDS_ORDERS: 'Delete KDS orders',
  DEALS_CRON_JOB: 'Deals cron job',
  EMPLOYEE_TIME_CARD_CRON_JOB: 'Employee timecard cron job',
  GUEST_TIME_CARD_CRON_JOB: 'Guest cron job',
  GUEST_SEGMENT_CRON_JOB: 'Guest segment cron job',
  INTEGRATION_CRON_JOB: 'Integration cron job',
  JOURNEY_CRON_JOB: 'Journey cron job',
  DAILY_CRON_JOB: 'Daily report cron job',
  WEEKLY_REPORT_JOB: 'Weekly report cron job',
  ACCOUNTING_RECALC_JOB: 'Accounting recalculation job',
  WEBSITE_ANALYTICS_JOB: 'Website analytics cron job',
  TRIPADVISOR_JOB: 'Tripadvisor cron job',
  AI_REVIEWS_JOB: 'AI reviews cron job',
  AI_REVIEWS_SCRAPER_JOB: 'AI reviews scraper cron job',
  CAMPAIGN_APPROVAL_REMINDER_JOB: 'Campaign approval reminder cron job',
  CAMPAIGN_MISSED_JOB: 'Campaign missed cron job',
  DOC_VAULT_EXPIRY_JOB: 'Doc vault expiry cron job',
  SUCCESSFUL_CLOSEOUT_EMAIL_JOB: 'Successful closeout email cron job',
  ANDROMEDA_JOB: 'Andromeda Job',
  DELETE_HELP_REQUESTS: 'Delete Help Requests',
  CAPTURE_PAYMENT_JOB: 'Capture Payment Job',
};

export const ANDROMEDA_QUEUE_TRANSACTIONS = {
  GENERAL_QUEUE: 'General Queue Message',
  JOURNEY_QUEUE: 'Journey Queue Message',
  MQTT_QUEUE: 'MQTT Queue Message',
  CAMPAIGN_QUEUE: 'Campaign Queue Message',
  DEAL_QUEUE: 'Deal Queue Message',
  DEFAULT_QUEUE: 'Queue Message',
};

export const ANDROMEDA_NOTIFICATION_TRANSACTIONS: Record<NotificationType, string> = {
  [NotificationType.SMS]: 'SMS Notification',
  [NotificationType.FCM]: 'FCM Notification',
  [NotificationType.MQTT]: 'MQTT Publish',
  [NotificationType.EMAIL]: 'Email Notification',
  [NotificationType.BULK_EMAIL]: 'Bulk Email Notification',
  [NotificationType.SOCIALS]: 'Social Notification',
  [NotificationType.DEALS]: 'Deals Notification',
  [NotificationType.CAMPAIGNS]: 'Campaign Notification',
  [NotificationType.CONTENT_CHEF]: 'Content Chef Notification',
  [NotificationType.ANALYTICS]: 'Analytics Notification',
  [NotificationType.JOURNEYS]: 'Journeys Notification',
  [NotificationType.INVENTORY]: 'Inventory Notification',
  [NotificationType.GIFT_CARD_INVENTORY_IMPORT]: 'Gift Card Inventory Import Notification',
  [NotificationType.ARM]: 'ARM Notification',
  [NotificationType.ARM_STORE_REVIEW]: 'ARM Store Review Notification',
  [NotificationType.IMPORT_GUESTS]: 'Import Guest Notification',
  [NotificationType.ACTIVITY_LOG]: 'Activity Log Notification',
};

export const LOYALTY_ITEMS_LIMIT = 10;
export const STAGE_ENV_S3_URL = 'aio-dashboard-filestore.s3.us-west-2.amazonaws.com';
export const CLOUD_FRONT_URL = 'd397eean0u41g4.cloudfront.net';

export const DEFAULT_JOURNEY_POSITIONS = [
  JourneyPositionEnum.LOGO,
  JourneyPositionEnum.MAIN,
  JourneyPositionEnum.DEAL,
  JourneyPositionEnum.SPOTLIGHT,
  JourneyPositionEnum.ITEM,
];

export const MIN_ATTEMPTS = 1;

export const LOYALTY_STEPS = 500;

export const OFF_PREM_SOURCES = [OrderSource.Website, OrderSource.Doordash];
export const ON_PREM_SOURCES = [OrderSource.POS, OrderSource.Kiosk, OrderSource.MPOS, OrderSource.QR];

export const INTERNAL_REVIEW_SOURCES = [ReviewSource.INTERNAL, ReviewSource.NUGGET, ReviewSource.ONLINE];

export const contactSupport = {
  toMail: 'support@aioapp.com',
};
export const RECONCILIATION_AUTO_MATCH_DAYS_DIFFERENCE = 30;

export const DefaultConutriesCodes = ['+1', '+92'];

export const GIFT_CARD_IMAGES_LIMIT = 3;

export const AvgPrepTimeLimits = {
  MaxInMinutes: 4320, //72 hours
  MinInMinutes: 1,
};

export const YELP_BUSINESS_SCOPES = ['r2r', 'r2r_business_owner', 'r2r_get_businesses'];

export enum IMPORT_GUESTS_PLATFORMS {
  FIVE_STAR = '5Stars',
  TOAST = 'Toast',
  SPOT_HOPPER = 'SpotHopper',
  POP_MENU = 'PopMenu',
  VENU_MANAGER = 'VenuManager',
  SQUARE = 'Square',
  CLOVER = 'Clover',
  // CAKE = 'Cake',
}

export enum LOYALTY_PLATFORMS {
  FIVE_STAR = '5Stars',
}

export const FIVE_START_CUSTOMER_SOURCE_MAP: Record<string, string> = {
  'store registration': OrderSource.POS,
  'store registration - cts': OrderSource.POS,
  'nearby save - cts': OrderSource.Kiosk,
  'nearby save': OrderSource.Kiosk,
  'shortcode registration': 'guestbook',
  'online registration': OrderSource.Website,
  'fivestars network': 'guestbook',
  'nearby save - cma': OrderSource.Kiosk,
  'data upload': 'guestbook',
  nearbuy: OrderSource.Kiosk,
  referral: 'guestbook',
  'web api': OrderSource.Website,
  'nearby share': OrderSource.Kiosk,
  'nearby save - cmv': OrderSource.Kiosk,
};

export const FIVE_STAR_SEGMENT = {
  new: GuestSegmentTypes.NEW,
  regular: GuestSegmentTypes.REGULAR,
  vip: GuestSegmentTypes.REGULAR,
  inactive: GuestSegmentTypes.LOST,
  online: GuestSegmentTypes.POTENTIAL,
  imported: GuestSegmentTypes.POTENTIAL,
};

export enum GuestImportType {
  Guest = 'guest',
  Loyalty = 'loyalty',
}

export const IMPORT_FILE_SIZE_LIMIT_IN_MB = 5 * 1024 * 1024;

export const SERVER_ERROR_MESSAGES: Record<number, string> = {
  500: 'Something went wrong on our side. Please try again.',
  501: 'This feature is not available yet.',
  502: "We're having trouble connecting to our services. Please try again.",
  503: 'The service is temporarily unavailable. Please try again shortly.',
  504: 'The server took too long to respond. Please try again.',
  505: 'Your request is not supported. Please try a different method.',
  506: 'We hit an unexpected issue. Please try again.',
  507: 'The server is low on space. Please try later.',
  508: 'The server ran into an unexpected loop. Please try again.',
  510: 'The server needs additional information. Please try again.',
  511: 'Network authentication is required.',
};

export const NETWORK_ERROR_MESSAGES: Record<string, string> = {
  ECONNREFUSED: 'Cannot connect to the server. Please try again shortly.',
  ECONNRESET: 'The connection was interrupted. Please try again.',
  ENOTFOUND: 'The server address could not be found. Please try again.',
  ETIMEDOUT: 'The request took too long. Please try again.',
  EAI_AGAIN: 'Temporary network issue. Please try again.',
  EHOSTUNREACH: 'The server is unreachable. Please check your connection.',
  ENETUNREACH: 'The network is unreachable. Please check your connection.',
  EPIPE: 'Connection was broken. Please try again.',
  ERR_NETWORK: 'There was a network issue. Please try again.',
  ERR_CONNECTION_REFUSED: 'The connection was refused. Please try again.',
  ERR_CONNECTION_RESET: 'The connection was reset. Please try again.',
  ERR_INTERNET_DISCONNECTED: 'You are offline. Please check your internet connection.',
  ERR_CERT_COMMON_NAME_INVALID: 'Secure connection failed due to certificate issue.',
  ERR_CERT_AUTHORITY_INVALID: 'Could not verify server security certificate.',
  ERR_NAME_NOT_RESOLVED: 'Unable to find the server. Please try again.',
  ERR_SSL_PROTOCOL_ERROR: 'A secure connection error occurred. Please try again.',
};

export const GC_MIN_LIMIT = 5;
export const GC_MAX_LIMIT = 500;

export const GIFT_CARD_CSV_HEADERS = {
  accountId: 'Account ID',
  cardNumbers: 'Card Numbers',
};
export const GIFT_CARD_IMPORT_BATCH_SIZE = 100;
export const GC_IMPORT_LOG_PREFIX = 'GIFT CARDS INVENTORY IMPORT:';
export const GIFT_CARD_CATEGORY_LIMIT = 15;

export const US_FORMAT = 'MM/DD/YYYY';
